import {
    addTagsToInstance,
    attachFileToInstanceById,
    cloneBoInstance,
    createBoInstance,
    deleteBoInstancesByIds,
    deleteBoRelationshipsByIds,
    downloadAllFilesByInstanceId,
    downloadFileById,
    downloadFilesByIds,
    exportLogs,
    getAllFilesByInstanceId,
    getLogs,
    getNotificationLogsByInstanceId,
    getBoTypeById,
    getBoInstanceData,
    getBoInstanceRelationships,
    getBusinessObjects,
    removeTagsFromInstance,
    updateInstance,
    startDataLoadJob,
    getFile,
    getAllDataViewsByBOId,
} from "../../actions/boCoreActions";
import * as React                           from "react";
import {Ref, useEffect, useRef, useState}   from "react";
import {Prompt, RouteComponentProps}        from "react-router";
import Utils                                from "../../Utils";
import * as agGrid                          from "ag-grid-community";
import * as toastr                          from "toastr";
import SplitterLayout                       from 'react-splitter-layout';
import AsyncCreatable                       from "react-select/async-creatable";
import Axios                                from "../../config/Axios";
import getAttributesEditor                  from "./common/AgInstanceAttributes";
import {Tab, TabList, TabPanel, Tabs}       from 'react-tabs';
import history                              from '../../config/history'
import RelationshipsModal                   from '../../components/bo-core/modals/RelationshipsModal'
import LookupInstanceModal                  from "../../components/bo-core/modals/LookupInstanceModal";
import {SLIDE}                              from "../../views/bo-core/Accordeon";
import {AttributeTypeEnum}                  from "./enums/AttributeTypeEnum";
import Dropzone                             from 'react-dropzone';
import ActionSpinner                        from "../common/ActionSpinner";
import _                                    from "lodash";
import 'react-splitter-layout/lib/index.css';
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham-dark.css"
import 'react-tabs/style/react-tabs.css';
import AuditLogChangesModal from "./modals/AuditLogChangesModal";
import LoadingModal from "./modals/LoadinModal";
import ReactJson from "react-json-view";
import ReactDOM from "react-dom";
import {useSelector} from "react-redux";

const hash = require('object-hash');
const deepEqual = require('deep-equal');
const FileSaver = require('file-saver');
const queryString = require('query-string');
const arrayDiff = require('simple-array-diff');

const $cloneTargetContentModel = Utils.$('<div id="qtipContainer"></div>')
    .append($("<label>How many copies would you like to create?</label>"))
    .append($("<input id='numberOfCopies' style='border: 1px solid #9f9f9f; background: #2D3436; color: #b5b5b5; width: 100%; height: 30px; font-size: 14px' type='number' value='1' min='1' max='999'/>"))
    .append($("<label style='padding-top: 5px'>Clone Relationships:</label>"))
    .append($("<input id='cloneRelsToggle' type='checkbox' data-onstyle='primary' data-offstyle='danger' data-toggle='toggle' data-width='100%' data-height='20'/>"))
    .append($("<label style='padding-top: 5px'>Clone Related Instances:</label>"))
    .append($("<input disabled='true' id='cloneRelatedInstances' type='checkbox' data-onstyle='primary' data-offstyle='danger' data-toggle='toggle' data-width='100%' data-height='20'/>"))
    .append($("<label style='padding-top: 5px'>Share Cloned Related Instances:</label>"))
    .append($("<input disabled='true' id='shareClonedInstances' type='checkbox' data-onstyle='primary' data-offstyle='danger' data-toggle='toggle' data-width='100%' data-height='20'/>"))
    .append($("<input id='submitCopies' class='btn btn-success' type='submit' style='margin-top: 15px; width: 100%;' value='Submit'/>"));


const $uploadFile = Utils.$('<div id="qtipContainerImport"></div>')
        .append($("<label>Is File Public:</label>"))
        .append($("<input id='multiValueToggle' type='checkbox' data-onstyle='primary' data-offstyle='danger' data-toggle='toggle' data-width='100%' data-height='20'/>"))
        .append($("<div style='padding-top: 5px' id='buttons-container'/>")
        .append($("<input id='choose-files' style='float: left' type='file' />"))
        .append($("<input id='submit-files' type='button' style='float: right; color: black' value='Submit'/>")));

// @ts-ignore
declare const API_BASE_URL = API_BASE_URL;

interface Props extends RouteComponentProps {
    slide: SLIDE,
    setBusinessObject(obj: any): void;
    switchRequest: boolean;
    switchTab(confirmed: boolean): void;
    backToList(boName: string): void;
}

export enum ResizeActions {
    FIT_CONTENT = 'Fit Content',
    FIT_SCREEN = 'Fit Screen'
}

export default function InstanceGridEditor(props: Props) {
    const [leave, setLeave] = useState<boolean>(false);
    const [hasConfirmDialog, setHasConfirmDialog] = useState<boolean>(false);

    const tabsRef: Ref<any> = React.createRef();
    const instanceNameRef: Ref<HTMLInputElement> = React.createRef();

    const relationshipsModal = useRef(null);
    const lookupInstanceModal = useRef(null);
    const auditLogChangesRef = useRef(null);

    const [instance, _setInstance] = useState<any>(null);
    const [instanceFiles, _setInstanceFiles] = useState<any[]>([]);
    const [instanceLog, _setinstanceLog] = useState<any[]>([]);
    const [businessObject, setBusinessObject] = useState<any>(null);
    const [businessObjects, setBusinessObjects] = useState<any[]>([]);

    const [attributesGrid, _setAttributesGrid] = useState<any>(null);
    const [relationshipsGrid, _setRelationshipsGrid] = useState<any>(null);
    const [fileAttachmentsGrid, _setFileAttachmentsGrid] = useState<any>(null);
    const [logGrid, _setLogGrid] = useState<any>(null);
    const [notificationGrid, _setNotificationGrid] = useState<any>(null);
    const [selectedLogEntry, setSelectedLogEntry] = useState<any>(null);

    const [typeKey, setTypeKey] = useState<string>(null);

    const [toRelationships, setToRelationships] = useState<any[]>([]);
    const [fromRelationships, setFromRelationships] = useState<any[]>([]);
    const [isInitialLogRequest, setIsInitialLogRequest] = useState<boolean>(true);
    const [isCloning, setIsCloning] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);

    const [logOldValue, setLogOldValue] = useState<any>(null);
    const [logNewValue, setLogNewValue] = useState<any>(null);
    const [instanceRelationships, setInstanceRelationships] = useState<any>([]);

    const instanceRef = React.useRef(instance);
    const fileAttachmentsGridRef = React.useRef(fileAttachmentsGrid);
    const logGridRef = React.useRef(logGrid);
    const notificationGridRef = React.useRef(notificationGrid);
    const relationshipsGridRef = React.useRef(relationshipsGrid);
    const attributesGridRef = React.useRef(attributesGrid);
    const instanceFilesRef = React.useRef(instanceFiles);
    const instanceLogRef = React.useRef(instanceLog);
    const [resizeAction, setAction] = useState(ResizeActions.FIT_CONTENT);
    const [cloneTargetContent, setCloneTargetContent] = useState<any>($cloneTargetContentModel.clone());
    const [uploadFileTargetContent, setUploadFileTargetContent] = useState<any>($uploadFile.clone());
    const locale = useSelector((store: any) => store.auth.locale);

    const setInstance = inst => {
        instanceRef.current = inst;
        _setInstance(inst);
    };

    const setFileAttachmentsGrid = att => {
        fileAttachmentsGridRef.current = att;
        _setFileAttachmentsGrid(att);
    };

    const setLogGrid = att => {
        logGridRef.current = att;
        _setLogGrid(att);
    };

    const setNotificationGrid = att => {
        notificationGridRef.current = att;
        _setNotificationGrid(att);
    };

    const setRelationshipsGrid = att => {
        relationshipsGridRef.current = att;
        _setRelationshipsGrid(att);
    };

    const setAttributesGrid = att => {
        attributesGridRef.current = att;
        _setAttributesGrid(att);
    };

    const setInstanceFiles = files => {
        instanceFilesRef.current = files;
        _setInstanceFiles(files);
    };

    const setInstanceLog = log => {
        instanceLogRef.current = log;
        _setinstanceLog(log);
    };

    const autoSizeAllColumns = (params) => {
        let allColumnIds = [];
        params.columnApi.getAllColumns().forEach((column) => {
            allColumnIds.push(column.colId);
        });
        params.columnApi.autoSizeColumns(allColumnIds, false);

        if (resizeAction !== ResizeActions.FIT_SCREEN) {
            setAction(ResizeActions.FIT_SCREEN)
        }
    };

    const onResizeColumns = () => {
        if (resizeAction === ResizeActions.FIT_SCREEN) {
            fitScreenColumns();
        } else {
            autoSizeAllColumns(attributesGrid.gridOptions);
        }
    };

    const fitScreenColumns = () => {
        attributesGrid.gridOptions.columnApi.resetColumnState();
        attributesGrid.gridOptions.api.sizeColumnsToFit();
        if (resizeAction !== ResizeActions.FIT_CONTENT) {
            setAction(ResizeActions.FIT_CONTENT);
        }
    };

    let permissions = {
        'image/bmp': true,
        'image/gif': true,
        'image/png': true,
        'image/jpeg': true,
        'image/jpg': true,
        'image/tiff': true
    };

    function getType(types) {
        for (let j = 0; j < types.length; ++j) {
            let type = types[j];
            if (permissions[type]) {
                return type;
            }
        }
        return null;
    }

    function getItem(items) {
        for (let i = 0; i < items.length; ++i) {
            let item = items[i];
            if (item) {
                let type = getType(item.types);
                if (type) {
                    return item.getType(type);
                }
            }
        }
        return null;
    }

    function getClipboardContents() {
        try {
            //@ts-ignore
            let promise = navigator.clipboard.read();
            promise
                .then(function (items) {
                    let promise = getItem(items);
                    if (promise == null) {
                        return;
                    }
                    promise
                        .then(function (result) {
                            let fileType = result.type ? result.type.split('/')[1] : 'png';
                            result.name = `image-${Utils.moment().format("MM-DD-YYYY-HH-mm-ss")}.${fileType}`;
                            attachFileToInstanceById(instanceRef.current.id, result)
                                .then(() => {
                                    getInstanceFiles();
                                    getInstanceRelationships();
                                    getInstanceLog();
                                });
                        })
                        .catch(function (error) {
                            toastr.warning("Reading clipboard error.");
                            console.log("Reading clipboard error", error);
                        });
                })
                .catch(function (error) {
                    toastr.warning("Reading clipboard error.");
                    console.log('Reading clipboard error.', error);
                });
        } catch (err) {
            console.error(err.name, err.message);
        }
    }

    const keydownHandler = (e) => {
        if (e.keyCode === 86 && e.ctrlKey) {
            getClipboardContents();
        }
        if (e.ctrlKey && e.altKey && e.keyCode === 82) {
            Utils.$('.react-tabs__tab-list').children(':first').click();
        }
        if (e.ctrlKey && e.altKey && e.keyCode === 65) {
            Utils.$('.react-tabs__tab-list').children(':nth-child(2)').click();
        }
        if (e.ctrlKey && e.altKey && e.keyCode === 76) {
            Utils.$('.react-tabs__tab-list').children(':nth-child(3)').click();
        }
        if (e.ctrlKey && e.altKey && e.keyCode === 84) {
            Utils.$('.react-tabs__tab-list').children(':nth-child(4)').click();
        }
        if (e.ctrlKey && e.altKey && e.keyCode === 78) {
            Utils.$('#new-instance-btn').click();
        }
        if (e.ctrlKey && e.altKey && e.keyCode === 74) {
            Utils.$('#start-data-load-job').click();
        }
        if (e.ctrlKey && e.altKey && e.keyCode === 67) {
            Utils.$('#clone-instance-btn').click();
        }
        if (e.ctrlKey && e.altKey && e.keyCode === 83) {
            Utils.$('#save-instance-btn').click();
        }
        if (e.ctrlKey && e.altKey && e.keyCode === 8) {
            Utils.$('#back-to-list').click();
        }
        if (e.ctrlKey && e.altKey && e.keyCode === 70) {
            Utils.$('#fit-content').click();
        }
        if (e.ctrlKey && e.altKey && e.keyCode === 69) {
            Utils.$('#new-relationship-btn').click();
        }
        if (e.ctrlKey && e.altKey && e.keyCode === 86) {
            Utils.$('#view-log-btn').click();
        }
        if (e.ctrlKey && e.altKey && e.keyCode === 77) {
            Utils.$('#view-notification-log-btn').click();
        }
        if (e.ctrlKey && e.altKey && e.keyCode === 88) {
            Utils.$('#export-log-btn').click();
        }
    };

    const setNewInstance = (response, query, orderedAttributes?) => {
        let businessObject;
        for (let item of response.data) {
            if (item.id == query.bocId) {
                if (orderedAttributes) {
                    item.attributes = orderedAttributes;
                }
                businessObject = item;
            }
            businessObjects.push(item);
        }
        setBusinessObject(businessObject);
        setInstance({
            id: -1,
            name: "",
            boClass: {
                id: businessObject.id,
                name: businessObject.name,
                description: businessObject.description,
                systemRequired: businessObject.systemRequired
            },
            created: "",
            updated: "",
            updatedByUser: "",
            tags: [],
            attachments: null,
            relationships: [],
            attributes: businessObject.attributes.map((item, index) => {
                switch (item.type) {
                    case AttributeTypeEnum.VALUE_LIST:
                        return {
                            order: index,
                            attribute: item,
                            value: [item.attributeValues.find(attribVal => attribVal.id == item.defaultValue).name]
                        };
                    case AttributeTypeEnum.LOOKUP:
                        return {
                            order: index,
                            attribute: item,
                            value: JSON.parse(item.defaultValue)
                        };
                    case AttributeTypeEnum.INCREMENTING:
                        return {
                            order: index,
                            attribute: item,
                            value: ""
                        };
                    case AttributeTypeEnum.EMAIL: {
                        return {
                            order: index,
                            attribute: item,
                            value: Utils.parseEmailAttributeDefaultValue(item.defaultValue, item.attributeValues)
                        };
                    }
                    default:
                        return {
                            order: index,
                            attribute: item,
                            value: item.defaultValue
                        }
                }
            })
        })
        setTimeout(() => {
            let tabs = document.getElementsByClassName('react-tabs__tab');
            // @ts-ignore
            tabs[0].click();
        }, 300);
    };

    useEffect(() => {
        if (props.switchRequest === true) {
            handleBlockedNavigation(null);
        }
    }, [props.switchRequest])

    useEffect(() => {
        buildAttributesGrid(setAttributesGrid, lookupInstanceModal, businessObjects, locale);
        buildRelationshipsGrid(setRelationshipsGrid);
        buildFileAttachmentsGrid(setFileAttachmentsGrid);
        buildLogGrid(setLogGrid);
        buildNotificationGrid(setNotificationGrid);
        instanceNameRef.current.focus();
        document.addEventListener('keydown', keydownHandler);
        return () => {
            document.removeEventListener('keydown', keydownHandler);
            // remove remaining datepicker
            Utils.$('.xdsoft_datetimepicker').remove();
            Utils.$('#ui-datepicker-div').remove();
            // remove remaining select
            Utils.$('#select2-drop').remove();
            Utils.$('#select2-drop-mask').remove();
            // remove remaining qtip
            Utils.$(".qtip").remove();
        };
    }, []);

    useEffect(() => {
        if (props.slide === SLIDE.GRID_EDITOR) {
            if (props.match.params['id']) {
                if (props.match.params['id'] !== "-1") {
                    getBoInstanceData({instanceId: parseInt(props.match.params['id']), dataView: "full"})
                        .then(responses => {
                            const query = queryString.parse(props.location.search);

                            for (let item of responses[0].data) {
                                const boClassId = responses[1].data.boClass.id;
                                if (item.id == boClassId) {
                                    item.attributes.forEach(attribA => {
                                        responses[1].data.attributes.find(attribB => attribB.attribute.id == attribA.id).attribute.attributeValues = attribA.attributeValues;
                                    });
                                     getBoTypeById(boClassId)
                                        .then(response => setTypeKey(response.data.boKey));
                                    setBusinessObject(item);
                                }
                                businessObjects.push(item)
                            }
                            responses[1].data.attributes.forEach((item) => {
                                switch (item.attribute.type) {
                                    case AttributeTypeEnum.TIME:
                                        item.value = Utils.utcToLocalTime(item.value);
                                        break;
                                    case AttributeTypeEnum.TIMESTAMP:
                                        item.value = Utils.utcToLocalDate(item.value);
                                        break;
                                    case AttributeTypeEnum.DECIMAL:
                                        let strValue = item.value.toString();
                                        if (strValue.indexOf('.') === -1 && strValue.indexOf(',') === -1) {
                                            if (item.attribute.minDigitsRightOfDecimal !== -1) {
                                                item.value = parseFloat(item.value).toFixed(item.attribute.minDigitsRightOfDecimal);
                                            }
                                        }
                                        break;
                                }
                            });
                            if (query.clone === "true") {
                                responses[1].data.name = `Copy Of ${responses[1].data.name}`;
                            }
                            responses[1].data.created = Utils.utcToLocalDate(responses[1].data.created);
                            responses[1].data.updated = Utils.utcToLocalDate(responses[1].data.updated);

                            setInstance(responses[1].data);
                            const currBusinessObj = {
                                id: responses[1].data.boClass.id,
                                name: responses[1].data.boClass.name
                            }
                            props.setBusinessObject(currBusinessObj);
                            if (query.logId) {
                                setTimeout(() => {
                                    let tabs = document.getElementsByClassName('react-tabs__tab');
                                    // @ts-ignore
                                    tabs[2].click();
                                }, 1000)
                            }
                        })
                        .catch(() => {
                            history.push(`${process.env.ENV_PREFIX}/managedata`);
                        })
                } else {
                    getBusinessObjects()
                        .then(response => {
                            const query = queryString.parse(props.location.search);
                            if (query.bocId) {
                                getAllDataViewsByBOId(query.bocId)
                                    .then(dataViewResponse => {
                                        const fullView = dataViewResponse.data.find(el => el.viewName === "full");
                                        if (fullView) {
                                            const orderedAttributes = fullView.columns.filter(col => col.type === "attribute").map(el => {
                                                return {
                                                    ...el.value,
                                                    columnOrder: el.columnOrder
                                                }
                                            });
                                            setNewInstance(response, query, orderedAttributes);
                                        } else {
                                            setNewInstance(response, query);
                                        }
                                    })
                                    .catch(error => {
                                        toastr.error(error.response.data.message);
                                        setNewInstance(response, query);
                                    })
                            } else {
                                history.push(`${process.env.ENV_PREFIX}/managedata`);
                            }
                        })
                }
            } else {
                history.push(`${process.env.ENV_PREFIX}/managedata`);
            }
        }
    }, [props.match.params['id'], props.location.search, props.slide]);

    useEffect(() => {
        instanceNameRef.current.focus();
        if (instance) {
            setLeave(false);
            relationshipsGrid.gridOptions.api["instance"] = instance;

            const nameAttr = instance.attributes.find(item => item.attribute.name.toLowerCase() === "name");
            let attributes = instance.attributes.filter(item => nameAttr !== item);
            if (selectedLogEntry) {
                attributes.unshift(nameAttr);
            }
            attributesGrid.gridOptions.api.setRowData(getAttributes(attributes));

            if (isCloning) {
                if (tabsRef.current.state.selectedIndex === 0) {
                    getInstanceRelationships();
                }
                if (tabsRef.current.state.selectedIndex === 1) {
                    getInstanceFiles();
                }
                if (tabsRef.current.state.selectedIndex === 2) {
                    getInstanceLog();
                }
                setIsCloning(false);
            } else {
                if (tabsRef.current.state.selectedIndex !== 2) {
                    getInstanceRelationships();
                    getInstanceFiles();
                }
            }
        }
    }, [instance]);

    useEffect(() => {
        if (instance) {
            const query = queryString.parse(props.location.search);
            if (instance.id !== -1 && (!query.clone || query.clone != "true")) {
                if (fromRelationships.length > 0 || toRelationships.length > 0) {
                    onSave();
                    setToRelationships([]);
                    setFromRelationships([]);
                }
            } else {
                relationshipsModal.current.hide();
                const dataArray = fromRelationships.map(item => item.relGridItem).concat(toRelationships.map(item => item.relGridItem));
                relationshipsGrid.gridOptions.api.setRowData(dataArray);
            }
        }
    }, [fromRelationships, toRelationships]);

    useEffect(() => {
        if (attributesGrid) {
            if (selectedLogEntry) {
                let newInstance = _.cloneDeep(instance);
                newInstance.attributes.forEach((attr, index) => {
                    const parsedOldValue = JSON.parse(selectedLogEntry.oldValue);
                    const parsedNewValue = JSON.parse(selectedLogEntry.newValue);

                    switch (attr.attribute.type){
                        case AttributeTypeEnum.TIME:
                            newInstance.attributes[index]['oldValue'] = parsedOldValue && Object.keys(parsedOldValue).length > 0 ?
                                parsedOldValue[attr.attribute.key] ? Utils.utcToLocalTime(parsedOldValue[attr.attribute.key]) : '' : '';
                            newInstance.attributes[index]['newValue'] = parsedNewValue && Object.keys(parsedNewValue).length > 0 ?
                                parsedNewValue[attr.attribute.key] ? Utils.utcToLocalTime(parsedNewValue[attr.attribute.key]) : '' : '';
                            break;
                        case AttributeTypeEnum.TIMESTAMP:
                            newInstance.attributes[index]['oldValue'] = parsedOldValue && Object.keys(parsedOldValue).length > 0 ?
                                parsedOldValue[attr.attribute.key] ? Utils.utcToLocalDate(parsedOldValue[attr.attribute.key]) : '' : '';
                            newInstance.attributes[index]['newValue'] = parsedNewValue && Object.keys(parsedNewValue).length > 0 ?
                                parsedNewValue[attr.attribute.key] ? Utils.utcToLocalDate(parsedNewValue[attr.attribute.key]) : '' : '';
                            break;
                        case AttributeTypeEnum.JSON:
                            newInstance.attributes[index]['oldValue'] = parsedOldValue && Object.keys(parsedOldValue).length > 0 ?
                                parsedOldValue[attr.attribute.key] ? JSON.stringify(parsedOldValue[attr.attribute.key]) : '' : '';
                            newInstance.attributes[index]['newValue'] = parsedNewValue && Object.keys(parsedNewValue).length > 0 ?
                                parsedNewValue[attr.attribute.key] ? JSON.stringify(parsedNewValue[attr.attribute.key]) : '' : '';
                            break;
                        default:
                            newInstance.attributes[index]['oldValue'] = parsedOldValue && Object.keys(parsedOldValue).length > 0 ?
                                parsedOldValue[attr.attribute.key] ? parsedOldValue[attr.attribute.key] : '' : '';
                            newInstance.attributes[index]['newValue'] = parsedNewValue && Object.keys(parsedNewValue).length > 0 ?
                                parsedNewValue[attr.attribute.key] ? parsedNewValue[attr.attribute.key] : '' : '';
                            break;
                    }
                });

                setInstance(newInstance);
                const newColDefs = [
                    {
                        field: "uiSection",
                        headerName: 'UI Section',
                        rowGroup: true,
                        hide: true,
                    },
                    {
                        field: 'name',
                        headerName: "Attribute Name",
                        tooltipField: 'name',
                        headerTooltip: "Attribute Name",
                        width: 50,
                        suppressNavigable: true
                    },
                    {
                        field: 'type',
                        headerName: "Type",
                        tooltipField: 'type',
                        headerTooltip: "Attribute Type",
                        width: 50,
                        suppressNavigable: true
                    },
                    {
                        editable: false,
                        field: 'oldValue',
                        colKey: 'oldValue',
                        headerName: "Old Value",
                        tooltipField: 'oldValue',
                        headerTooltip: "Old Value",
                        cellEditor: 'agInstanceAttributes',
                        width: 50,
                        cellRenderer: (params) => {
                            if (!params.node.group) {
                                if (params.data.type === AttributeTypeEnum.LOOKUP) {
                                    return `<span>${params.data.oldValue ? params.data.oldValue.value : ''}</span>`;
                                }
                                if (params.data.type === AttributeTypeEnum.EMAIL) {
                                    return `<span>${Utils.parseEmailAttributeValue(
                                        params.data.oldValue && params.data.oldValue.length > 0 ?  params.data.oldValue : '')}</span>`;
                                }
                                if (params.data.type === AttributeTypeEnum.TEXT || params.data.type === AttributeTypeEnum.JSON) {
                                    const eDiv = document.createElement('div');
                                    eDiv.innerHTML = `<span style="max-width: 70%; word-wrap: break-word; white-space: nowrap; text-overflow: ellipsis; overflow: hidden">${params.data.oldValue}</span>
                                    <span><button id="previewTxtBtn" style="float: right; background-color: transparent; border: transparent;">
                                    <i class="fas fa-search fa-lg"></i></button></span>`;
                                    const eButton = eDiv.querySelectorAll('#previewTxtBtn')[0];
                                    eDiv.style.cssText = 'display: flex; white-space: initial; justify-content: space-between';
                                    params.readonly = true;

                                    eButton.addEventListener('click', function(event) {
                                        if (params.data.type === AttributeTypeEnum.TEXT) {
                                            showTextArea(event,params, false, attributesGrid.gridOptions);
                                        } else {
                                            showJSONComponent(event,params, false, attributesGrid.gridOptions);
                                        }
                                    });

                                    return eDiv;
                                }
                                return `<span>${params.data.oldValue}</span>`
                            }
                        },
                    },
                    {
                        editable: false,
                        field: 'newValue',
                        colKey: 'newValue',
                        headerName: "New Value",
                        tooltipField: 'newValue',
                        headerTooltip: "New Value",
                        cellEditor: 'agInstanceAttributes',
                        width: 50,
                        cellRenderer: (params) => {
                            if (!params.node.group) {
                                if (params.data.type === AttributeTypeEnum.LOOKUP) {
                                    return `<span>${params.data.newValue ? params.data.newValue.value : ''}</span>`;
                                }
                                if (params.data.type === AttributeTypeEnum.EMAIL) {
                                    return `<span>${Utils.parseEmailAttributeValue(
                                        params.data.newValue && params.data.newValue.length > 0 ? params.data.newValue : '')}</span>`;
                                }
                                if (params.data.type === AttributeTypeEnum.TEXT || params.data.type === AttributeTypeEnum.JSON) {
                                    const eDiv = document.createElement('div');
                                    eDiv.innerHTML = `<span style="max-width: 70%; word-wrap: break-word; white-space: nowrap; text-overflow: ellipsis; overflow: hidden">${params.data.newValue}</span>
                                    <span><button id="previewTxtBtn" style="float: right; background-color: transparent; border: transparent;">
                                    <i class="fas fa-search fa-lg"></i></button></span>`;
                                    const eButton = eDiv.querySelectorAll('#previewTxtBtn')[0];
                                    eDiv.style.cssText = 'display: flex; white-space: initial; justify-content: space-between';
                                    params.readonly = true;

                                    eButton.addEventListener('click', function(event) {
                                        if (params.data.type === AttributeTypeEnum.TEXT) {
                                            showTextArea(event,params, false, attributesGrid.gridOptions);
                                        } else {
                                            showJSONComponent(event,params, false, attributesGrid.gridOptions);
                                        }
                                    });

                                    return eDiv;
                                }
                                return `<span>${params.data.newValue}</span>`
                            }
                        },
                    },
                ];
                attributesGrid.gridOptions.api.setColumnDefs([]);
                attributesGrid.gridOptions.api.setColumnDefs(newColDefs);
                attributesGrid.gridOptions.api.sizeColumnsToFit();
            } else {
                const standardColDefs = [
                    {
                        field: "uiSection",
                        headerName: 'UI Section',
                        rowGroup: true,
                        hide: true,
                    },
                    {
                        field: 'name',
                        headerName: "Attribute Name",
                        tooltipField: 'name',
                        headerTooltip: "Attribute Name",
                        width: 50,
                        suppressNavigable: true
                    },
                    {
                        field: 'type',
                        headerName: "Type",
                        tooltipField: 'type',
                        headerTooltip: "Attribute Type",
                        width: 50,
                        suppressNavigable: true
                    },
                    {
                        editable: true,
                        field: 'value',
                        colKey: 'value',
                        headerName: "Value",
                        tooltipField: 'value',
                        headerTooltip: "Attribute Value",
                        cellEditorSelector: params => attributesGridCellEditorSelector(params),
                        width: 50,
                        cellRenderer: (params) => attributesGridCellRenderer(params, attributesGrid.gridOptions, locale)
                    },
                ];
                attributesGrid.gridOptions.api.setColumnDefs([]);
                attributesGrid.gridOptions.api.setColumnDefs(standardColDefs);
                attributesGrid.gridOptions.api.sizeColumnsToFit();
                attributesGrid.gridOptions.api.setRowData(
                    getAttributes(instance.attributes.filter(item => item.attribute.name.toLowerCase() !== "name"))
                );
            }
        }
    }, [selectedLogEntry]);

    const onRelFilterTextBoxChanged = () => {
        relationshipsGrid.gridOptions.api.setQuickFilter((document.getElementById('rel-filter-text-box') as HTMLInputElement).value);
    };

    const onFileFilterTextBoxChanged = () => {
        fileAttachmentsGrid.gridOptions.api.setQuickFilter((document.getElementById('file-filter-text-box') as HTMLInputElement).value);
    };

    const onLogFilterTextBoxChanged = () => {
        logGrid.gridOptions.api.setQuickFilter((document.getElementById('log-filter-text-box') as HTMLInputElement).value);
    };

    const onNotificationFilterTextBoxChanged = () => {
        notificationGrid.gridOptions.api.setQuickFilter((document.getElementById('notification-filter-text-box') as HTMLInputElement).value);
    };

    const onSave = () => {
        attributesGrid.gridOptions.api.stopEditing();
        const query = queryString.parse(props.location.search);

        const dto = {
            tags: [],
            attributes: {},
            toRelationships: toRelationships,
            fromRelationships: fromRelationships
        };

        if (instance.id === -1 || (query.clone && query.clone === "true")) {
            const attributes = attributesGrid.gridOptions.api.getAllRows();
            attributes.forEach((item: any) => {
                switch (item.type) {
                    case AttributeTypeEnum.EMAIL:
                        dto.attributes[item.id] = Utils.parseEmailAttributeValue(item.value);
                        break;
                    case AttributeTypeEnum.VALUE_LIST:
                        dto.attributes[item.id] = item.value.map(val => item.attributeValues.find(attribVal => attribVal.name.toLowerCase() == val.toLowerCase()).id);
                        break;
                    case AttributeTypeEnum.LOOKUP:
                        dto.attributes[item.id] = item.value.id;
                        break;
                    case AttributeTypeEnum.TIMESTAMP:
                        dto.attributes[item.id] = Utils.localToUtc(item.value, 'YYYY-MM-DD HH:mm:ss',
                            Utils.BACKEND_DATE_TIME_FORMAT);
                        break;
                    case AttributeTypeEnum.TIME:
                        dto.attributes[item.id] = Utils.localTimeToUtc(item.value);
                        break;
                    default:
                        dto.attributes[item.id] = item.value;
                }
            });

            dto.tags = instance.tags;

            dto.attributes[businessObject.attributes.find(item => item.name.toLowerCase() === "name").id] = instanceNameRef.current.value;

            createBoInstance(businessObject.id, "full", dto)
                .then(response => {
                    setLeave(true);
                    setToRelationships([]);
                    setFromRelationships([]);
                    history.replace(`${process.env.ENV_PREFIX}/instance/${response.data.id}`);
                })

        } else {
            const tempAttributes = getAttributes(instance.attributes);
            const attributes = attributesGrid.gridOptions.api.getAllRows();
            const nameAttribute = tempAttributes.find(item => item.name.toLowerCase() === "name");

            if (instanceNameRef.current.value !== nameAttribute.value) {
                dto.attributes[nameAttribute.id] = instanceNameRef.current.value;
            }

            attributes.forEach((attribute: any) => {
                if (!equal(attribute.value, tempAttributes.find(item => item.id == attribute.id).value)) {
                    switch (attribute.type) {
                        case AttributeTypeEnum.EMAIL:
                            if (attribute.value === '') {
                                dto.attributes[attribute.id] = [];
                            } else {
                                dto.attributes[attribute.id] = attribute.value.split(',');
                            }
                            break;
                        case AttributeTypeEnum.VALUE_LIST:
                            dto.attributes[attribute.id] = attribute.value.map(val => attribute.attributeValues.find(attribVal => attribVal.name.toLowerCase() == val.toLowerCase()).id);
                            break;
                        case AttributeTypeEnum.LOOKUP:
                            dto.attributes[attribute.id] = attribute.value.id;
                            break;
                        case AttributeTypeEnum.TIMESTAMP:
                            dto.attributes[attribute.id] = Utils.localToUtc(attribute.value, 'YYYY-MM-DD HH:mm:ss',
                                Utils.BACKEND_DATE_TIME_FORMAT);
                            break;
                        case AttributeTypeEnum.TIME:
                            dto.attributes[attribute.id] = Utils.localTimeToUtc(attribute.value);
                            break;
                        default:
                            dto.attributes[attribute.id] = attribute.value;
                    }
                }
            });

            if (hasChanges(dto)) {
                updateInstance(instance.id, "full", dto)
                    .then((response: any) => {
                        businessObject.attributes.forEach(attribA => {
                            response.data.attributes.find(attribB => attribB.attribute.id == attribA.id).attribute.attributeValues = attribA.attributeValues;
                        });
                        response.data.attributes.forEach((item) => {
                            switch (item.attribute.type) {
                                case AttributeTypeEnum.TIME:
                                    item.value = Utils.utcToLocalTime(item.value);
                                    break;
                                case AttributeTypeEnum.TIMESTAMP:
                                    item.value = Utils.utcToLocalDate(item.value);
                                    break;
                                case AttributeTypeEnum.DECIMAL:
                                    let strValue = item.value.toString();
                                    if (strValue.indexOf('.') === -1 && strValue.indexOf(',') === -1) {
                                        if (item.attribute.minDigitsRightOfDecimal !== -1) {
                                            item.value = parseFloat(item.value).toFixed(item.attribute.minDigitsRightOfDecimal);
                                        }
                                    }
                                    break;
                            }
                        });
                        response.data.created = Utils.utcToLocalDate(response.data.created);
                        response.data.updated = Utils.utcToLocalDate(response.data.updated);
                        setInstance(response.data);
                        relationshipsModal.current.hide();
                        // Timeout is set because of database delays
                        setTimeout(() => getInstanceLog(), 1000);
                    })
            } else {
                toastr.warning("There are no changes.");
            }
        }
    };

    const equal = (a: any, b: any): boolean => {
        return deepEqual(a, b);
    };

    const onNew = () => {
        relationshipsGrid.gridOptions.api.setRowData([]);
        fileAttachmentsGrid.gridOptions.api.setRowData([]);
        logGrid.gridOptions.api.setRowData([]);
        history.replace(`${process.env.ENV_PREFIX}/instance/-1?bocId=${businessObject.id}`);
    };

    const onStartJob = () => {
        startDataLoadJob(instance.id)
            .then(response => {
                toastr.success("Job started successfully.");
            })
            .catch(error => {
                toastr.error(error.response.data.message);
            })
    };

    const onClone = (e) => {
        const $cloneTargetContent = cloneTargetContent.clone();
        Utils.$(e.target).qtip({
            content: {
                title: function () {
                    return "Manage Data Cloning"
                },
                text: $cloneTargetContent,
                button: "Close"
            },
            show: true,
            hide: "unfocus",
            events: {
                show: () => {
                    $(e.target).css("background-color", "#676A6C");
                },
                hide: () => {
                    Utils.$(e.target).css("background-color", "#1AB394");
                    Utils.$('.qtip-dark').remove();
                    Utils.$(e.target).qtip('destroy');
                },
                visible: () => {
                    document.getElementById("numberOfCopies").focus();
                },
                render: () => {
                    let includeRelationships = "No";
                    let cloneRelatedInstances = "No";
                    let shareClonedInstances = "No";
                    let $cloneRelsToggle = $cloneTargetContent.children("#cloneRelsToggle").bootstrapToggle({
                        height: 30,
                        on: 'Yes',
                        off: 'No'
                    });

                    let $cloneRelatedInstances = $cloneTargetContent.children("#cloneRelatedInstances").bootstrapToggle({
                        height: 30,
                        on: 'Yes',
                        off: 'No'
                    });

                    let $shareClonedInstances= $cloneTargetContent.children("#shareClonedInstances").bootstrapToggle({
                        height: 30,
                        on: 'Yes',
                        off: 'No'
                    });

                    // Clone relationships
                    $cloneRelsToggle.focus().select();
                    $cloneRelsToggle.change(function () {
                        if ($cloneRelsToggle[0].checked) {
                            includeRelationships = "Yes";
                            $cloneRelatedInstances.bootstrapToggle('enable');
                            $shareClonedInstances.bootstrapToggle('enable');
                        } else {
                            includeRelationships = "No";
                            cloneRelatedInstances = "No";
                            shareClonedInstances = "No";
                            Utils.$("#cloneRelatedInstances").parent().removeClass('btn-primary').addClass('btn-danger off')
                            $cloneRelatedInstances[0].checked = false
                            Utils.$("#shareClonedInstances").parent().removeClass('btn-primary').addClass('btn-danger off')
                            $shareClonedInstances[0].checked = false
                            $cloneRelatedInstances.bootstrapToggle('disable');
                            $shareClonedInstances.bootstrapToggle('disable');
                        }
                    });

                    //Clone Related Instances
                    $cloneRelatedInstances.focus().select();
                    $cloneRelatedInstances.change(function () {
                        if ($cloneRelatedInstances[0].checked) {
                            cloneRelatedInstances = "Yes";
                        } else {
                            cloneRelatedInstances = "No";
                        }
                    });
                    // Share Cloned Instances
                    $shareClonedInstances.focus().select();
                    $shareClonedInstances.change(function () {
                        if ($shareClonedInstances[0].checked) {
                            shareClonedInstances = "Yes";
                        } else {
                            shareClonedInstances = "No";
                        }
                    });
                    Utils.$("#cloneRelsToggle").parent(".toggle")[0].title = 'CTRL + LEFT_ARROW or RIGHT_ARROW';

                    function submitClone() {
                        const warningMessage = 'Please enter an integer in the range from 1 to 999';
                        const numberOfCopies = parseFloat(Utils.$("#numberOfCopies")[0].value);
                        if (Number.isInteger(numberOfCopies) && numberOfCopies > 0 && numberOfCopies <= 999) {
                            Utils.$(".qtip").remove();
                            const dto = {
                                "cloneRelatedInstances": cloneRelatedInstances === 'Yes',
                                "copiesCount": numberOfCopies,
                                "includeRelationships": includeRelationships === "Yes",
                                "recordIds": [
                                    parseInt(props.match.params['id'])
                                ],
                                "shareClonedRelatedInstances": shareClonedInstances === 'Yes'
                            };
                            ActionSpinner.get(`/type/${businessObject.id}`, {}, {key: "getResourceType", showOnError: true}, false)
                                .then(response => {
                                    if (response) {
                                        cloneBoInstance(response.data.boKey, dto)
                                            .then(response => {
                                                setIsCloning(true);
                                                toastr.success(`${numberOfCopies} ${numberOfCopies === 1 ? 'copy has' : 'copies have'}` +
                                                    ` been created successfully`);
                                                     history.push(`${process.env.ENV_PREFIX}/instance/${response.data[0].id}`);
                                            });
                                    }
                                })
                        } else {
                            toastr.warning(warningMessage);
                        }
                    }
                    Utils.$("#submitCopies")
                        .unbind()
                        .on("click", () => {
                            if (Utils.$("#numberOfCopies")[0] && Utils.$("#numberOfCopies")[0].value) {
                                submitClone();
                            }
                        });
                    Utils.$("#numberOfCopies")
                        .unbind()
                        .on("keydown", (evt) => {
                            /* On enter key down */
                            if (evt.keyCode === 13 && Utils.$("#numberOfCopies")[0] && Utils.$("#numberOfCopies")[0].value) {
                                submitClone();
                            }
                        });
                    Utils.$('#numberOfCopies').on('propertychange input', function (e) {
                        const inputObj = Utils.$("#numberOfCopies")[0];
                        if (parseInt(inputObj.value) > parseInt(inputObj.max)){
                            inputObj.value = inputObj.value.slice(0,3);
                        }
                        if (parseInt(inputObj.value) < parseInt(inputObj.min)){
                            inputObj.value = '1'
                        }
                    });
                    Utils.$("#qtipContainer")
                        .unbind()
                        .on("keydown", (evt) => {
                            /* On arrows key down */
                            if ((evt.ctrlKey && evt.keyCode === 37 || (evt.ctrlKey && evt.keyCode === 39))) {
                                Utils.$("#cloneRelsToggle").bootstrapToggle('toggle');
                            }
                            /* On escape key down */
                            if (evt.keyCode === 27) {
                                Utils.$(".qtip").remove();
                                document.getElementById("save-instance-btn").focus();
                            }
                        });
                }
            },
            position: {
                my: 'top right',
                at: 'bottom center',
                viewport: $(document.body)
            },
            style: {
                classes: 'qtip-dark',
                width: 350
            }
        });
    };

    const onDownload = () => {
        downloadFileById(instance.id)
            .then(response => {
                FileSaver.saveAs(response.data, instance.name);
            })
    };

    const hasChanges = (dto: { tags: string[], toRelationships: any[], fromRelationships: any[], attributes: { [key: string]: any } }): boolean => {
        return Object.keys(dto.attributes).length !== 0 || dto.fromRelationships.length !== 0 || dto.toRelationships.length !== 0 || dto.tags.length !== 0;
    };

    const onTabChange = (newIndex: number) => {
        if (tabsRef.current.state.selectedIndex !== newIndex) {
            switch (newIndex) {
                case 0:
                    if (selectedLogEntry) {
                        setSelectedLogEntry(null);
                    }
                    getInstanceRelationships();
                    getInstanceFiles();
                    relationshipsGrid.gridOptions.api.sizeColumnsToFit();
                    break;
                case 1:
                    if (selectedLogEntry) {
                        setSelectedLogEntry(null);
                    }
                    getInstanceFiles();
                    fileAttachmentsGrid.gridOptions.api.sizeColumnsToFit();
                    break;
                case 2:
                    getInstanceLog();
                    logGrid.gridOptions.api.sizeColumnsToFit();
                    break;
                case 3:
                    if (selectedLogEntry) {
                        setSelectedLogEntry(null);
                    }
                    getNotificationLog();
                    notificationGrid.gridOptions.api.sizeColumnsToFit();
                    break;
            }
        }
    };

    const getInstanceRelationships = () => {
        if ((instance && instance.id != -1) || (instanceRef && instanceRef.current.id !== -1)) {
            let instId = instance && instance.id !== -1 ? instance.id : instanceRef.current.id;
            let relsGrid = relationshipsGrid ? relationshipsGrid : relationshipsGridRef.current;

            relsGrid.gridOptions.api.showLoadingOverlay();
            getBoInstanceRelationships(instId)
                .then(response => {
                    const relsGridRowData = response.data.map(item => {
                        if (item.fromBoInstance.id == instId) {
                            return {
                                id: item.id,
                                relationship: item.boRelType.name,
                                type: item.toBoInstance.boClass.name,
                                description: `${item.fromBoInstance.name} ${item.boRelType.inward} ${item.toBoInstance.name}`,
                                relatedRecord: {
                                    id: item.toBoInstance.id,
                                    name: item.toBoInstance.name
                                },
                                tags: item.toBoInstance.tags || [],
                                updated: Utils.utcToLocalDate(item.updated),
                                fromBoInstance: item.fromBoInstance,
                                toBoInstance: item.toBoInstance,
                                relTypeId: item.boRelType.id
                            }
                        } else {
                            return {
                                id: item.id,
                                relationship: item.boRelType.name,
                                type: item.fromBoInstance.boClass.name,
                                description: `${item.toBoInstance.name} ${item.boRelType.outward} ${item.fromBoInstance.name}`,
                                relatedRecord: {
                                    id: item.fromBoInstance.id,
                                    name: item.fromBoInstance.name
                                },
                                tags: item.fromBoInstance.tags || [],
                                updated: Utils.utcToLocalDate(item.updated),
                                fromBoInstance: item.fromBoInstance,
                                toBoInstance: item.toBoInstance,
                                relTypeId: item.boRelType.id
                            }
                        }
                    })
                    setInstanceRelationships(relsGridRowData);
                    relsGrid.gridOptions.api.setRowData(relsGridRowData);
                })
                .catch(() => {
                    relsGrid.gridOptions.api.hideOverlay();
                })
        }
    };

    const getInstanceFiles = () => {
        if ((instance && instance.id != -1) || (instanceRef && instanceRef.current.id !== -1)) {
            let instId = instance && instance.id !== -1 ? instance.id : instanceRef.current.id;
            let attachmentsGrid = fileAttachmentsGrid ? fileAttachmentsGrid : fileAttachmentsGridRef.current;
            attachmentsGrid.gridOptions.api.showLoadingOverlay();
            getAllFilesByInstanceId(instId)
                .then(response => {
                    setInstanceFiles(response.data);
                    attachmentsGrid.gridOptions.api.setRowData(response.data.map(item => {
                        return {
                            id: item.id,
                            name: item.name,
                            updated: Utils.utcToLocalDate(item.updated)
                        }
                    }));
                })
                .catch(() => {
                    attachmentsGrid.gridOptions.api.hideOverlay();
                });
        }
    };

    const getInstanceLog = () => {
        if ((instance && instance.id != -1) || (instanceRef && instanceRef.current.id !== -1)) {
            let instId = instance && instance.id !== -1 ? instance.id : instanceRef.current.id;
            let grid = logGrid ? logGrid : logGridRef.current;
            grid.gridOptions.api.showLoadingOverlay();
            getLogs({instanceId: instId})
                .then(response => {
                    setInstanceLog(response.data);
                    const gridData = response.data.data.map(item => {
                        return {
                            id: item.id,
                            stamp: Utils.utcToLocalDate(item.stamp),
                            username: item.username,
                            operation: item.operation,
                            oldValue: JSON.stringify(item.oldValue),
                            newValue: JSON.stringify(item.newValue)
                        }
                    });
                    grid.gridOptions.api.setRowData(gridData);
                    grid.gridOptions.api.sizeColumnsToFit();
                    if (isInitialLogRequest) {
                        setIsInitialLogRequest(false);
                        const query = queryString.parse(props.location.search);
                        if (query.logId) {
                            let selected = gridData.find(el => {
                                return el.id.toString() === query.logId.toString()
                            });
                            if (selected) {
                                setSelectedLogEntry(selected);
                                grid.gridOptions.api.forEachNode(node => {
                                    if (node.data.id === selected.id) {
                                        node.setSelected(true);
                                    }
                                });
                            }
                        }
                    }
                })
                .catch(() => {
                    grid.gridOptions.api.hideOverlay();
                });
        }
    };

    const getNotificationLog = () => {
        if ((instance && instance.id != -1) || (instanceRef && instanceRef.current.id !== -1)) {
            let instId = instance && instance.id !== -1 ? instance.id : instanceRef.current.id;
            let grid = notificationGrid ? notificationGrid : notificationGridRef.current;
            grid.gridOptions.api.showLoadingOverlay();
            getNotificationLogsByInstanceId(typeKey, instId)
                .then(response => {
                    const gridData = response.data.data.map(item => {
                        return {
                            recipient: item.recipient,
                            message: item.message,
                            type: item.type,
                            notificationSentTimestamp: Utils.utcToLocalDate(item.notificationSentTimestamp)
                        }
                    });
                    grid.gridOptions.api.setRowData(gridData);
                    grid.gridOptions.api.sizeColumnsToFit();
                })
                .catch(() => {
                    grid.gridOptions.api.hideOverlay();
                });
        }
    };

    const onUploadFile = () => {
        const file = Utils.$("#file").prop('files')[0];
        if (file) {
            attachFileToInstanceById(instance.id, file)
                .then(() => {
                    getInstanceFiles()
                })
        }
    };

    const uploadFileHandler = (e) => {
        const $uploadFile = uploadFileTargetContent.clone();

        Utils.$(e.target).qtip({
            content: {
                title: function () {
                    return "Upload File"
                },
                text: $uploadFile,
                button: "Close"
            },
            show: true,
            hide: "unfocus",
            events: {
                show: () => {
                    $(e.target).css("background-color", "#676A6C");
                },
                hide: () => {
                    Utils.$(e.target).css("background-color", "#1AB394");
                    Utils.$('.qtip-dark').remove();
                    Utils.$(e.target).qtip('destroy');
                },
                visible: () => {
                    document.getElementById("choose-files").focus();
                },
                render: () => {
                    let isPublic = false;
                    let $multiValueToggle = $uploadFile.children("#multiValueToggle").bootstrapToggle({
                        height: 30,
                        on: 'YES',
                        off: 'NO'
                    });
                    $multiValueToggle.focus().select();
                    $multiValueToggle.change(function () {
                        if ($multiValueToggle[0].checked) {
                            isPublic = true;
                        } else {
                            isPublic = false;
                        }
                    });

                    Utils.$("#submit-files")
                        .unbind()
                        .on("click", () => {
                            const file = Utils.$("#choose-files").prop("files")[0];

                            if (file) {
                                Utils.$('.qtip-dark').remove();
                                Utils.$(e.target).qtip('destroy');
                                attachFileToInstanceById(instance.id, file, isPublic)
                                    .then(() => {
                                        getInstanceFiles()
                                    })
                            }
                        })

                    Utils.$("#qtipContainerImport")
                        .unbind()
                        .on("keydown", (evt) => {
                            if (evt.keyCode === 27) {
                                Utils.$(".qtip").remove();
                            }
                        });

                }
            },
            position: {
                my: 'top right',
                at: 'bottom center',
                viewport: $(document.body)
            },
            style: {
                classes: 'qtip-dark',
                width: 350
            }
        });
    }


    const onDownloadFiles = () => {
        const rows = fileAttachmentsGrid.gridOptions.api.getSelectedRows();
        if (rows.length > 0) {
            if (rows.length > 1) {
                downloadFilesByIds(rows.map(item => item.id))
                    .then(response => {
                        FileSaver.saveAs(response.data, `${instance.name}_files.zip`);
                    })
            } else {
                downloadFileById(rows[0].id)
                    .then(response => {
                        FileSaver.saveAs(response.data, rows[0].name);
                    })
            }
        }
    };

    const onDeleteFiles = () => {
        const rows = fileAttachmentsGrid.gridOptions.api.getSelectedRows();
        if (rows.length > 0) {
            deleteBoInstancesByIds(rows.map(item => item.id))
                .then(() => {
                    getInstanceFiles();
                })
                .catch(() => {
                    getInstanceFiles();
                })
        }
    };

    const onSaveRelationships = (args: any) => {
        const toRel = [...toRelationships];
        const fromRel = [...fromRelationships];

        args.toRelationships.forEach(item => {
            if (toRel.findIndex(i => deepEqual(item, i)) == -1) {
                toRel.push(item);
            }
        });
        args.fromRelationships.forEach(item => {
            if (fromRel.findIndex(i => deepEqual(item, i)) == -1) {
                fromRel.push(item);
            }
        });

        const result = toRel.concat(fromRel);
        const relationshipsForDelete = [];

        instanceRelationships.forEach(item => {
            const found = result.find(searchedItem => item.relatedRecord.id === searchedItem.fromBoInstanceId);
            if (!found) {
               if (item.removedByUser) {
                   relationshipsForDelete.push(item)
               }
            }
        })

        if (relationshipsForDelete.length > 0) {
            onDeleteRelationships(true,relationshipsForDelete);
        }

        setToRelationships(toRel);
        setFromRelationships(fromRel);
    };

    const onSaveLookupAttribute = (data: any) => {
        const rowNode = attributesGrid.gridOptions.api.getRowNode(data.id);
        const rowData = rowNode.data;
        rowData.value = {
            id: data.instanceId,
            value: data.name
        };
        rowNode.setData(rowData);
    };

    const onNewRelationships = () => {
        relationshipsModal.current.show(businessObject, instanceNameRef.current.value, instance, instanceRelationships);
    };

    const onDeleteRelationships = (deleteFromModal?: boolean, itemsForDelete?: any) => {
        let rows;
        if (deleteFromModal) {
            rows = itemsForDelete;
        } else {
            rows = relationshipsGrid.gridOptions.api.getSelectedRows();
        }
        const instanceRelationshipsCopy = JSON.parse(JSON.stringify(instanceRelationships))
        if (rows.length > 0) {
            if (instance.id != -1) {
                deleteBoRelationshipsByIds(rows.map(item => item.id))
                    .then(() => {
                        relationshipsGrid.gridOptions.api.updateRowData({remove: rows});
                        rows.forEach(row => {
                            instanceRelationshipsCopy.splice(instanceRelationshipsCopy.findIndex(searched => searched.id === row.id), 1);
                        })
                        setInstanceRelationships(instanceRelationshipsCopy)
                        if (deleteFromModal) {
                            relationshipsModal.current.hide();
                        }
                    })
                    .catch(() => {
                        getInstanceRelationships();
                        getInstanceFiles();
                    })
            } else {
                const instanceRelationshipsCopy = JSON.parse(JSON.stringify(instanceRelationships))
                rows.forEach(row => {
                    instanceRelationshipsCopy.splice(instanceRelationshipsCopy.findIndex(searched => searched.id === row.id), 1);
                    toRelationships.splice(toRelationships.findIndex(item => deepEqual(item.relGridItem, row)), 1);
                    fromRelationships.splice(fromRelationships.findIndex(item => deepEqual(item.relGridItem, row)), 1);
                });
                relationshipsGrid.gridOptions.api.updateRowData({remove: rows});
                setInstanceRelationships(instanceRelationshipsCopy)
            }
        }
    };

    const onTagsChange = (tags: { label: string, value: string }[] | null) => {
        const result = arrayDiff(instance.tags, tags ? tags.map(tag => tag.label) : []);
        if (result.added.length) {
            if (instance) {
                if (instance.id != -1) {
                    addTagsToInstance(instance.id, result.added)
                        .then(() => {
                            result.added.forEach(tag => {
                                instance.tags.push(tag);
                            });
                        })
                } else {
                    result.added.forEach(tag => {
                        instance.tags.push(tag);
                    });
                }
            }
        } else if (result.removed.length) {
            if (instance) {
                if (instance.id != -1) {
                    removeTagsFromInstance(instance.id, result.removed)
                        .then(() => {
                            result.removed.forEach(tag => {
                                const index = instance.tags.indexOf(tag);
                                if (index !== -1) {
                                    instance.tags.splice(index, 1);
                                }
                            });
                        })
                } else {
                    result.removed.forEach(tag => {
                        const index = instance.tags.indexOf(tag);
                        if (index !== -1) {
                            instance.tags.splice(index, 1);
                        }
                    });
                }
            }
        }
    };

    const onDragEnd = () => {
        attributesGrid.gridOptions.api.sizeColumnsToFit();
        if (tabsRef.current.state.selectedIndex === 0) {
            relationshipsGrid.gridOptions.api.sizeColumnsToFit();
        } else if (tabsRef.current.state.selectedIndex === 1) {
            fileAttachmentsGrid.gridOptions.api.sizeColumnsToFit();
        } else if (tabsRef.current.state.selectedIndex === 2) {
            logGrid.gridOptions.api.sizeColumnsToFit();
        } else if (tabsRef.current.state.selectedIndex === 3) {
            notificationGrid.gridOptions.api.sizeColumnsToFit();
        }
    };

    const handleBlockedNavigation = nextLocation => {
        if (!instance) return true;
        let changes: boolean;
        const query = queryString.parse(props.location.search);

        attributesGrid.gridOptions.api.stopEditing();
        const dto = {
            tags: [],
            attributes: {},
            toRelationships: toRelationships,
            fromRelationships: fromRelationships
        };

        if (instance.id === -1) {
            const attributes = attributesGrid.gridOptions.api.getAllRows();
            attributes.forEach((item: any) => {
                switch (item.type) {
                    case AttributeTypeEnum.EMAIL:
                        dto.attributes[item.id] = item.value;
                        break;
                    case AttributeTypeEnum.VALUE_LIST:
                        dto.attributes[item.id] = item.value.map(val => item.attributeValues.find(attribVal => attribVal.name.toLowerCase() == val.toLowerCase()).id);
                        break;
                    case AttributeTypeEnum.LOOKUP:
                        dto.attributes[item.id] = item.value.id;
                        break;
                    default:
                        dto.attributes[item.id] = item.value;
                }
            });

            dto.tags = instance.tags;

            dto.attributes[businessObject.attributes.find(item => item.name.toLowerCase() === "name").id] = instanceNameRef.current.value;

            changes = hasChanges(dto);
        } else {
            const tempAttributes = getAttributes(instance.attributes);
            const attributes = attributesGrid.gridOptions.api.getAllRows();
            const nameAttribute = tempAttributes.find(item => item.name.toLowerCase() === "name");

            if (instanceNameRef.current.value !== nameAttribute.value) {
                dto.attributes[nameAttribute.id] = instanceNameRef.current.value;
            }

            attributes.forEach((attribute: any) => {
                if (!equal(attribute.value, tempAttributes.find(item => item.id == attribute.id).value)) {
                    switch (attribute.type) {
                        case AttributeTypeEnum.EMAIL:
                            const tmpAttrVal = tempAttributes.find(item => item.id == attribute.id).value;
                            if (attribute.value !== '' || (Array.isArray(attribute.value) && attribute.value.length !== 0)) {
                               const parsedValue = '['
                                    + attribute.value
                                        .split(',')
                                        .map((v) => `"${v}"`)
                                        .join(',')
                                    + ']';

                                if (parsedValue !== tmpAttrVal) {
                                    dto.attributes[attribute.id] = attribute.value;
                                }
                            } else {
                                if (attribute.value === '' && tmpAttrVal !== '[]') {
                                    dto.attributes[attribute.id] = [];
                                }
                            }
                            break;
                        case AttributeTypeEnum.VALUE_LIST:
                            dto.attributes[attribute.id] = attribute.value.map(val => attribute.attributeValues.find(attribVal => attribVal.name.toLowerCase() == val.toLowerCase()).id);
                            break;
                        case AttributeTypeEnum.LOOKUP:
                            dto.attributes[attribute.id] = attribute.value.id;
                            break;
                        default:
                            dto.attributes[attribute.id] = attribute.value;
                    }
                }
            });
            changes = hasChanges(dto);
        }


        if (hasConfirmDialog) {
            return false
        } else if ((changes || query.clone && query.clone === "true") && !leave) {
            Utils.$.confirm({
                title: (query.clone && query.clone === "true") ? "You are about to cancel instance cloning!!!" : "There are unsaved changes!!!",
                content: 'Are you sure you want to leave?',
                keyboardEnabled: true,
                escapeKey: 'cancel',
                backgroundDismiss: false,
                type: 'red',
                theme: 'dark',
                typeAnimated: false,
                buttons: {
                    ok: {
                        text: "Yes!",
                        btnClass: 'btn-danger',
                        keys: ['enter'],
                        action: () => {
                            setLeave(true);
                            setHasConfirmDialog(false);
                            if (nextLocation) {
                                history.push(nextLocation);
                            } else {
                                props.switchTab(true);
                            }
                        }
                    },
                    cancel: function () {
                        setHasConfirmDialog(false);
                        if (!nextLocation) {
                            props.switchTab(false);
                        }
                    }
                }
            });
            setHasConfirmDialog(true);
            return false
        }
        if (!nextLocation) {
            props.switchTab(true);
        }
        return true
    };

    const withClone = (): boolean => {
        const query = queryString.parse(props.location.search);
        return props.match.params['id'] !== "-1" && (!query.clone || query.clone !== "true");
    };


    const buildRelationshipsGrid = (setGrid: any) => {
        const gridOptions: any = {
            defaultColDef: {
                filter: "agTextColumnFilter",
                sortable: true,
                resizable: true
            },
            rowData: [],
            floatingFilter: true,
            rowSelection: 'multiple',
            groupUseEntireRow: true,
            groupSelectsChildren: true,
            groupSelectsFiltered: true,
            suppressDragLeaveHidesColumns: true,
            groupDefaultExpanded: -1,
            groupRowRendererParams: {
                checkbox: true
            },
            columnDefs: [
                {
                    field: 'relationship',
                    headerName: "Relationship",
                    tooltipField: 'relationship',
                    headerTooltip: "Relationship",
                    checkboxSelection: true,
                    headerCheckboxSelection: true
                },
                {
                    field: 'description',
                    headerName: "Description",
                    tooltipField: 'description',
                    headerTooltip: "Description"
                },
                {
                    field: 'relatedRecord.name',
                    headerName: 'Name Of Related Record',
                    tooltipField: 'nameOfRelatedRecord',
                    headerTooltip: 'Name Of Related Record',
                    cellRenderer: 'nameCellRenderer'
                },
                {
                    field: 'tags',
                    headerName: "Tags",
                    tooltipField: 'tags',
                    headerTooltip: "Tags"
                },
                {
                    field: 'updated',
                    headerName: "Updated",
                    tooltipField: 'updated',
                    headerTooltip: "Updated"
                },
                {
                    field: 'type',
                    headerName: "Type",
                    rowGroup: true,
                    hide: true,
                    valueGetter: (params) => {
                        const query = queryString.parse(props.history.location.search);
                        if (params.data.type.toLowerCase() === "file" && params.api.instance.id != -1 && (!query.clone || query.clone != "true")) {
                            return `${params.data.type} (Click to download all)`;
                        } else {
                            return `${params.data.type}`;
                        }
                    }
                },
            ],
            onGridReady: (params: any) => {
                params.api.sizeColumnsToFit();
            },
            onRowClicked: (params: any) => {
                if (params.node.group && params.node.key.toLowerCase() === "file (click to download all)") {
                    downloadAllFilesByInstanceId(params.api.instance.id)
                        .then(response => {
                            FileSaver.saveAs(response.data, `${params.api.instance.name}_files.zip`);
                        })
                }
            },
            components: { nameCellRenderer: getRenderer() },
            suppressRowTransform: true
        };

        function getRenderer() {
            function CellRenderer() {}
            CellRenderer.prototype.createGui = function() {
                const template =
                    '<span><button id="previewBtn" style="float: left; background-color: transparent; border: transparent; padding-left: 0;">' +
                    '<i class="fas fa-search fa-lg"></i></button><span id="nameVal" style="cursor: pointer; color: #5baeff"></span></span>';
                const tempDiv = document.createElement("div");
                tempDiv.innerHTML = template;
                this.eGui = tempDiv.firstElementChild;
            };
            CellRenderer.prototype.init = function(params) {
                this.createGui();
                this.params = params;
                const eValue = this.eGui.querySelector("#nameVal");
                eValue.innerHTML = params.value;
                this.eButton = this.eGui.querySelector("#previewBtn");
                let lastDotIndex = this.params.value.lastIndexOf('.');
                let fileExtension = this.params.value.slice(lastDotIndex+1);
                if (permissions['image/'+fileExtension]) {
                    this.eButton.style.display = 'block'
                } else {
                    this.eButton.style.display = 'none'
                }
                this.eButton.title = "Show Preview";
                this.eValue = this.eGui.querySelector("#nameVal");
                this.eValue.title = this.params.value;
                this.buttonClickListener = this.onButtonClicked.bind(this);
                this.valueClickListener = this.onValueClicked.bind(this);
                this.eButton.addEventListener("click", this.buttonClickListener);
                this.eValue.addEventListener("click", this.valueClickListener);
            };
            CellRenderer.prototype.onButtonClicked = function() {
                const openedImage = document.getElementById("data-entry-img-container");
                if (openedImage) {
                    openedImage.remove();
                }
                let lastDotIndex = this.params.value.lastIndexOf('.');
                let fileExtension = this.params.value.slice(lastDotIndex+1);
                if (permissions['image/'+fileExtension]) {
                    const image = document.createElement('img');
                    const div = document.createElement('div');
                    const loading = document.createElement('h1');
                    loading.innerHTML = "Loading...";
                    loading.id = 'loader-img-container'
                    div.id = 'data-entry-img-container';
                    let angle = 0;
                    div.innerHTML = "<div id='rotation-btns-container'>" +
                        "<button id='btn-undo' class='btn'><i class='fas fa-undo'> Rotate</i></button> " +
                        "<button id='btn-redo' class='btn'><i class='fas fa-redo'> Rotate</i></button>" +
                        "<button id='btn-img-close' class='btn'><i class='fas fa-times'> Close</i></button>" +
                        "</div>";
                    div.getElementsByClassName('btn')[0].addEventListener('click', function () {
                        angle -= 90;
                        $('#openedImage').css('transform','rotate(' + angle + 'deg)');
                    });
                    div.getElementsByClassName('btn')[1].addEventListener('click', function () {
                        angle += 90;
                        $('#openedImage').css('transform','rotate(' + angle + 'deg)');
                    });
                    div.getElementsByClassName('btn')[2].addEventListener('click', function () {
                        div.remove();
                        attributesGridRef.current.gridOptions.api.sizeColumnsToFit();
                    });
                    image.id = "openedImage";
                    if (this.params.data.relatedRecord && this.params.data.relatedRecord.id) {
                        getFile(this.params.data.relatedRecord.id).then(response => {
                            if (response) {
                                image.src = window.URL.createObjectURL(response.data);
                            } else {
                                toastr.error('Problem with image preview arised.');
                            }
                        })
                    }
                    image.onload = function() {
                        loading.style.display = 'none';
                    };
                    image.title = "Click to Close";
                    image.onclick = function() {
                        div.remove();
                        attributesGridRef.current.gridOptions.api.sizeColumnsToFit();
                    };
                    image.style.width = "100%";
                    image.style.zIndex = "100";
                    image.style.cursor = "pointer";
                    div.appendChild(image);
                    div.appendChild(loading);
                    const paneLayouts = document.getElementsByClassName("layout-pane layout-pane-primary");
                    paneLayouts[1].appendChild(div);
                } else {
                    toastr.warning('Preview is available only for image files');
                }
            };
            CellRenderer.prototype.onValueClicked = function() {
                window.open(`#/instance/${this.params.data.relatedRecord.id}`, "_blank");
            };
            CellRenderer.prototype.getGui = function() {
                return this.eGui;
            };
            CellRenderer.prototype.destroy = function() {
                this.eButton.removeEventListener("click", this.buttonClickListener);
                this.eValue.removeEventListener("click", this.valueClickListener);
            };
            return CellRenderer;
        }

        const grid: any = new agGrid.Grid(document.getElementById("relationshipsGrid"), gridOptions);

        gridOptions.api.getAllRows = (): any[] => {
            const data = [];
            gridOptions.api.rowModel.gridApi.forEachNode((node) => {
                data.push(node.data);
            });
            return data
        };

        gridOptions.getRowStyle = (params) => {
            if (params.node.group && params.node.key.toLowerCase() === "file (click to download all)") {
                return {color: "#2500ac", cursor: "pointer"}
            }
        };

        setGrid(grid);
    };

    const onBackToList = () => {
        props.backToList(instance.boClass.name.toLowerCase());
    };

    const onDrop = (newFiles) => {
        newFiles.forEach(file => {
            attachFileToInstanceById(instance.id, file)
                .then(() => {
                    getInstanceFiles();
                    getInstanceRelationships();
                    getInstanceLog();
                });
        });
    };

    const nameKeyDownListener = (e) => {
        if (e.ctrlKey && e.altKey) {
            e.preventDefault();
        }
        if (e.keyCode === 9) {
            e.preventDefault();

            // scrolls to the first row
            attributesGridRef.current.gridOptions.api.ensureIndexVisible(0);

            // scrolls to the current column
            let currentCol = attributesGridRef.current.gridOptions.columnApi.getAllDisplayedColumns()[2];
            attributesGridRef.current.gridOptions.api.ensureColumnVisible(currentCol);

            // sets focus into the grid cell
            attributesGridRef.current.gridOptions.api.setFocusedCell(1, currentCol);
            let currentCell = attributesGridRef.current.gridOptions.api.getFocusedCell();

            attributesGridRef.current.gridOptions.api.startEditingCell({
                rowIndex: currentCell.rowIndex,
                colKey: currentCell.column.colId
            })
        }
    };

    const nextCellForEdit = () => {
        let currentCell = attributesGridRef.current.gridOptions.api.getFocusedCell();
        let finalRowIndex = attributesGridRef.current.gridOptions.api.paginationGetRowCount() - 1;
        const suppressMoveToNext = currentCell === null ? true : currentCell.rowIndex === finalRowIndex;
        // If we are editing the last row in the grid, don't move to next line
        if (suppressMoveToNext) {
            return;
        }
        attributesGridRef.current.gridOptions.api.ensureIndexVisible(currentCell.rowIndex + 1);
        // scrolls to the current column
        let currentCol = attributesGridRef.current.gridOptions.columnApi.getAllDisplayedColumns()[2];
        attributesGridRef.current.gridOptions.api.ensureColumnVisible(currentCol);
        // sets focus into the grid cell
        attributesGridRef.current.gridOptions.api.setFocusedCell(currentCell.rowIndex + 1, currentCol);

        attributesGridRef.current.gridOptions.api.startEditingCell({
            rowIndex: currentCell.rowIndex + 1,
            colKey: currentCell.column.colId
        })
    };

    const selectKeyDownListener = (e) => {
        if (e.keyCode === 9) {
            e.preventDefault();
            instanceNameRef.current.focus();
        }
        if(e.ctrlKey && e.altKey && e.keyCode === 83) {
            e.preventDefault();
        }
    };

    const onLogExport = () => {
        let instId = instance && instance.id !== -1 ? instance.id : instanceRef.current.id;
        setLoading(true);
        exportLogs({instanceId: instId})
            .then(response => {
                const url = window.URL.createObjectURL(response.data);
                const link: any = document.createElement("a");
                link.href = url;
                link.style = "display: none";
                link.download = `Audit-Log-Export_${instance.name}_${Date.now()}.xlsx`;
                document.body.appendChild(link);
                link.click();
                window.URL.revokeObjectURL(url);
            })
            .catch(error => {
                toastr.error(error.response.data.message);
            })
            .finally(() => setLoading(false))
    };

    const onViewLog = () => {
        const rows = logGrid.gridOptions.api.getSelectedRows();
        if (rows.length === 1) {
            const oldVal = JSON.parse(rows[0].oldValue);
            const newVal = JSON.parse(rows[0].newValue);
            setLogOldValue(oldVal);
            setLogNewValue(newVal);
            auditLogChangesRef.current.open();
        } else if (rows.length === 0) {
            toastr.warning("Please select one log entry.");
        } else {
            toastr.warning("Please select only one log entry.");
        }
    };

    const buildLogGrid = (setGrid: any) => {
        const gridOptions: any = {
            defaultColDef: {
                filter: "agTextColumnFilter",
                sortable: true,
                resizable: true
            },
            rowData: [],
            floatingFilter: true,
            rowSelection: 'multiple',
            suppressDragLeaveHidesColumns: true,
            columnDefs: [
                {
                    field: 'stamp',
                    headerName: "Timestamp",
                    tooltipField: 'stamp',
                    headerTooltip: "Timestamp",
                    checkboxSelection: true,
                    headerCheckboxSelection: true
                },
                {
                    field: 'username',
                    headerName: "Username",
                    tooltipField: 'username',
                    headerTooltip: "Username"
                },
                {
                    field: 'operation',
                    headerName: "Changes",
                    tooltipField: 'operation',
                    headerTooltip: "Changes",
                },
                {
                    field: 'oldValue',
                    headerName: "Old Value",
                    tooltipField: 'oldValue',
                    headerTooltip: "Old Value",
                },
                {
                    field: 'newValue',
                    headerName: "New Value",
                    tooltipField: 'newValue',
                    headerTooltip: "New Value",
                }
            ],
            onRowSelected: (params: any) => {
                if (params.api.getSelectedRows().length === 1) {
                    if (!selectedLogEntry || (selectedLogEntry && selectedLogEntry.id !== params.api.getSelectedRows()[0].id)) {
                        setSelectedLogEntry(params.api.getSelectedRows()[0]);
                    }
                } else {
                    setSelectedLogEntry(null);
                }
            },
        };

        const grid: any = new agGrid.Grid(document.getElementById("logGrid"), gridOptions);

        gridOptions.api.getAllRows = (): any[] => {
            const data = [];
            gridOptions.api.rowModel.gridApi.forEachNode((node) => {
                data.push(node.data);
            });
            return data
        };

        setGrid(grid);
    };

    const buildNotificationGrid = (setGrid: any) => {
        const gridOptions: any = {
            defaultColDef: {
                filter: "agTextColumnFilter",
                sortable: true,
                resizable: true
            },
            rowData: [],
            floatingFilter: true,
            suppressDragLeaveHidesColumns: true,
            columnDefs: [
                {
                    field: 'notificationSentTimestamp',
                    headerName: "Notification Sent",
                    tooltipField: 'notificationSentTimestamp',
                    headerTooltip: "Notification Sent",
                    width: 150
                },
                {
                    field: 'recipient',
                    headerName: "Recipient",
                    tooltipField: 'recipient',
                    headerTooltip: "Recipient",
                    width: 210
                },
                {
                    field: 'message',
                    headerName: "Message",
                    tooltipField: 'message',
                    headerTooltip: "Message",
                    cellRenderer: 'nameCellRenderer'
                },
                {
                    field: 'type',
                    headerName: "Type",
                    tooltipField: 'type',
                    headerTooltip: "Type",
                    width: 120
                }
            ],
            components: {
                nameCellRenderer: getRenderer()
            }
        };

        function getRenderer() {
            function CellRenderer() {}
            CellRenderer.prototype.createGui = function() {
                const template =
                    '<span>' +
                    '<button id="previewBtn" style="float: left; background-color: transparent; border: transparent; padding-left: 0;">' +
                    '<i class="fas fa-search fa-lg"></i>' +
                    '</button>' +
                    '<span id="nameVal" />' +
                    '</span>';
                const tempDiv = document.createElement("div");
                tempDiv.innerHTML = template;
                this.eGui = tempDiv.firstElementChild;
            };
            CellRenderer.prototype.init = function(params) {
                this.createGui();
                this.params = params;
                const eValue = this.eGui.querySelector("#nameVal");
                eValue.innerHTML = params.value;
                this.eButton = this.eGui.querySelector("#previewBtn");
                this.eButton.title = "View Message";
                this.eValue = this.eGui.querySelector("#nameVal");
                this.eValue.title = this.params.value;
                this.buttonClickListener = this.onButtonClicked.bind(this);
                this.eButton.addEventListener("click", this.buttonClickListener);
                this.eValue.addEventListener("click", this.valueClickListener);
            };
            CellRenderer.prototype.onButtonClicked = function(e) {
                const areaParams = {
                    value: this.params.data.message,
                    readonly: true
                };
                showTextArea(e, areaParams, false, notificationGridRef.current.gridOptions, true);
            };
            CellRenderer.prototype.getGui = function() {
                return this.eGui;
            };
            CellRenderer.prototype.destroy = function() {
                this.eButton.removeEventListener("click", this.buttonClickListener);
                this.eValue.removeEventListener("click", this.valueClickListener);
            };
            return CellRenderer;
        }

        const grid: any = new agGrid.Grid(document.getElementById("notificationGrid"), gridOptions);

        gridOptions.api.getAllRows = (): any[] => {
            const data = [];
            gridOptions.api.rowModel.gridApi.forEachNode((node) => {
                data.push(node.data);
            });
            return data
        };

        setGrid(grid);
    };

    const getInstanceName = () => {
        if (instance && instance.attributes) {
            const attrName = instance.attributes.filter(item => item.attribute.name.toLowerCase() === "name");
            if (attrName.length > 0 && attrName[0].attribute.unique) {
                return `Unique ${instance.boClass.name} Name`
            } else {
                return `${instance.boClass.name} Name`
            }
        }
        return '...';
    }

    return (
        <div id={"instanceGridEditor"} style={{width: "100%", height: "100%"}}>
            <Dropzone
                onDrop={onDrop}
                noClick={true}
            >
                {({getRootProps, getInputProps}) => (
                    <div style={{height: '100%'}} {...getRootProps()}>
                        <input {...getInputProps()} hidden/>
                        <div style={{
                            width: "100%",
                            height: 65,
                            paddingTop: 5,
                            paddingBottom: 5,
                            paddingLeft: 5,
                            paddingRight: 5,
                            borderBottom: "2px solid black"
                        }} className={'background-gradient'}>
                            <div style={{
                                height: 16,
                                width: "100%",
                                display: "flex",
                                justifyContent: "space-between",
                                paddingRight: 2
                            }}>
                                <label className={'long-text-wrap'} style={{color: "#f5f4f4",}}>
                                    {getInstanceName()}
                                </label>
                                <label style={{color: '#f5f4f4', height: 16}} className={'long-text-wrap'}>
                                    {withClone() ? `Record updated by ${instance ? instance.updatedByUser : "..."} on ${instance ? instance.updated : "..."}` : null}
                                </label>
                            </div>
                            <div style={{
                                height: 36,
                                marginTop: 1,
                                marginLeft: "auto",
                                marginBottom: "auto"
                            }}>
                                <div style={{width: '100%', display: 'flex', paddingRight: 1}}>
                                    <input
                                        ref={instanceNameRef}
                                        key={instance ? instance.name : "..."}
                                        type={"text"}
                                        title={instance ? instance.name : "..."}
                                        style={{
                                            fontSize: 15,
                                            marginRight: 5,
                                            marginTop: 2,
                                            height: 34,
                                            border: 'none',
                                            borderRadius: 3,
                                            width: "calc(100% - 5px)"
                                        }}
                                        defaultValue={instance ? instance.name : "..."}
                                        tabIndex={1}
                                        onKeyDown={nameKeyDownListener}
                                        className={'new-design'}
                                    />
                                    {instance && (instance.boClass.name.toLowerCase() === "file" || instance.boClass.name.toLowerCase() === "file version") ?
                                        <div style={{display: "flex", paddingTop: 2}}>
                                            {instance && instance.boClass.name.toLowerCase() === "file" ?
                                                <button onClick={onDownload} style={{marginRight: 5}}
                                                        className={"btn btn-success"}>
                                                    <i className="fas fa-plus"> Download</i>
                                                </button>
                                                : null}
                                            <button onClick={onSave} style={{marginRight: 5}}
                                                    id={'save-instance-btn'}
                                                    className={"btn btn-primary"} title={'CTRL + ALT + S'}>
                                                <i className="fas fa-save"> <strong
                                                    className={'shortcut-btn-letters'}>S</strong>ave</i>
                                            </button>
                                            <button onClick={onBackToList} id={'back-to-list'}
                                                    className={"btn btn-new-design"} title={'CTRL + ALT + BACKSPACE'}>
                                                <i className="fas fa-backward"> Back To List</i>
                                            </button>
                                        </div>
                                        : <div style={{display: "flex", paddingTop: 2}}>
                                            <button id={'new-instance-btn'} onClick={onNew} style={{marginRight: 5}}
                                                    className={"btn btn-success"} title={'CTRL + ALT + N'}>
                                                <i className="fas fa-plus"> <strong
                                                    className={'shortcut-btn-letters'}>N</strong>ew</i>
                                            </button>
                                            {withClone() ?
                                                <button id={'clone-instance-btn'} onClick={onClone}
                                                        style={{marginRight: 5}}
                                                        className={"btn btn-warning"} title={'CTRL + ALT + C'}>
                                                    <i className="fas fa-clone"/>
                                                    <span className={'icon-style-text'} style={{pointerEvents: "none"}}> <strong
                                                        className={'shortcut-btn-letters'}>C</strong>lone</span>
                                                </button>
                                                : null}
                                            <button id={'save-instance-btn'} onClick={onSave} style={{marginRight: 5}}
                                                    className={"btn btn-primary"} title={'CTRL + ALT + S'}>
                                                <i className="fas fa-save"> <strong
                                                    className={'shortcut-btn-letters'}>S</strong>ave</i>
                                            </button>
                                            {instance && instance.boClass.name.toLowerCase() === "sys data load job" &&  instance.id !== -1 ?
                                                <button id={'start-data-load-job'} onClick={onStartJob} style={{marginRight: 5}}
                                                        className={"btn btn-new-design"} title={'CTRL + ALT + J'}>
                                                    <i className="fas fa-tasks"> Run <strong className={'shortcut-btn-letters'}>J</strong>ob</i>
                                                </button>
                                                : null}
                                            <button id={'fit-content'} onClick={onResizeColumns}
                                                    style={{marginRight: 5}}
                                                    className={"btn btn-new-design"} title={'CTRL + ALT + F'}>
                                                {resizeAction === ResizeActions.FIT_CONTENT ?
                                                    <i className="fa fa-expand"> <strong
                                                        className={'shortcut-btn-letters'}>F</strong>it Content</i> :
                                                    <i className="fas fa-compress-arrows-alt"> <strong
                                                        style={{textDecoration: 'underline'}}>F</strong>it screen</i>}
                                            </button>
                                            <button id={'back-to-list'} onClick={onBackToList}
                                                    className={"btn btn-new-design"} title={'CTRL + ALT + BACKSPACE'}>
                                                <i className="fas fa-backward"> Back To List</i>
                                            </button>
                                        </div>}
                                </div>
                            </div>
                        </div>
                        <div style={{height: "calc(100% - 65px)"}} id={'grid-container'}>
                            <SplitterLayout onDragEnd={onDragEnd} primaryIndex={1}>
                                <div style={{width: "100%", height: "100%", minWidth: 400}}>
                                    <SplitterLayout customClassName={"attribAndTagsSplitter"} vertical
                                                    secondaryInitialSize={45}>
                                        <div id={"attributesGrid"} className={"ag-theme-balham-dark ag-grids"}
                                             style={{width: "100%", height: "100%", paddingLeft: 5, paddingRight:5, paddingTop: 5, paddingBottom: 5}}/>
                                        <div style={{width: "100%", background: "#2D3436", height: "100%", paddingLeft: 5, paddingRight:5, paddingTop: 5}}>
                                            <AsyncCreatable
                                                key={hash(instance ? instance.tags : null)}
                                                isMulti={true}
                                                closeMenuOnSelect={false}
                                                menuPlacement={"top"}
                                                placeholder={"Tags"}
                                                defaultValue={instance ? instance.tags.map(item => {
                                                    return {
                                                        label: item,
                                                        value: item
                                                    }
                                                }) : null}
                                                defaultOptions
                                                loadOptions={loadingTags}
                                                onChange={onTagsChange}
                                                tabIndex={2}
                                                onKeyDown={selectKeyDownListener}
                                                styles={Utils.getReactSelectNewDesign()}
                                                theme={theme => ({
                                                    ...theme,
                                                    colors: {
                                                        ...theme.colors,
                                                        primary25: '#4e767a',
                                                        primary: '#3D6367',
                                                        primary50: '#4e767a'
                                                    },
                                                })}
                                            />
                                        </div>
                                    </SplitterLayout>
                                </div>
                                <div style={{width: "100%", height: "100%", minWidth: 400, backgroundColor: '#2D3436', paddingTop: 5}}>
                                    <Tabs ref={tabsRef} onSelect={onTabChange}>
                                        <TabList>
                                            <Tab title={'CTRL + ALT + R'}>
                                                <i className="fas fa-project-diagram"> Relationships</i>
                                            </Tab>
                                            <Tab title={'CTRL + ALT + A'} disabled={!instance || instance.id === -1 || instance.boClass.name.toLowerCase() === "file" }>
                                                <i className="fas fa-paperclip"> File Attachments</i>
                                            </Tab>
                                            <Tab title={'CTRL + ALT + L'} disabled={!instance || instance.id === -1}>
                                                <i className="fas fa-history"> Log</i>
                                            </Tab>
                                            <Tab title={'CTRL + ALT + N'}
                                                 disabled={!instance || instance.id === -1 || typeKey == null}>
                                                <i className="fas fa-bell"> Notifications</i>
                                            </Tab>
                                        </TabList>

                                        <TabPanel forceRender={true}>
                                            <div style={{height: 50, width: "100%", backgroundColor: '#2D3436', paddingTop: 5}}>
                                                <div style={{
                                                    width: "100%",
                                                    display: "flex",
                                                    height: 40,
                                                    padding: 2,
                                                    paddingRight: 5,
                                                    paddingLeft: 5,
                                                }}>
                                                    <input onInput={onRelFilterTextBoxChanged}
                                                           placeholder={"🔍 Global Search"}
                                                           id={'rel-filter-text-box'}
                                                           className={'new-design'}
                                                           style={{width: "inherit", fontSize: 16, border: 'none', borderRadius: 3}}/>
                                                    <button
                                                        onClick={onNewRelationships}
                                                        style={{marginLeft: 5}}
                                                        id={'new-relationship-btn'}
                                                        title={'CTRL + ALT + E'}
                                                        className={"btn btn-new-design"}>
                                                        <i className="fa fa-edit"/>
                                                        <span className={'icon-style-text'}> <strong className={'shortcut-btn-letters'}>E</strong>dit Relationships</span>
                                                    </button>
                                                    <button
                                                        onClick={() => onDeleteRelationships()}
                                                        style={{marginLeft: 5}}
                                                        className={"btn btn-danger"}><i
                                                        className="fas fa-trash-alt"> Delete</i>
                                                    </button>
                                                </div>
                                            </div>
                                            <div id={"relationshipsGrid"} className={"ag-theme-balham-dark ag-grids"}
                                                 style={{width: "100%", height: "calc(100% - 45px)", paddingLeft: 5, paddingRight: 5}}/>
                                        </TabPanel>
                                        <TabPanel forceRender={true}>
                                            <div style={{height: 50, width: "100%", backgroundColor: '#2D3436', paddingTop: 5}}>
                                                <div style={{
                                                    width: "100%",
                                                    display: "flex",
                                                    height: 40,
                                                    padding: 2,
                                                    paddingRight: 5,
                                                    paddingLeft: 5,
                                                }}>
                                                    <input onInput={onFileFilterTextBoxChanged}
                                                           placeholder={"🔍 Global Search"}
                                                           className={'new-design'}
                                                           id={'file-filter-text-box'}
                                                           style={{width: "inherit", fontSize: 16, border: 'none', borderRadius: 3}}/>
                                                    <button
                                                        onClick={uploadFileHandler}
                                                        style={{marginLeft: 5}}
                                                        className={"btn btn-new-design"}>
                                                        <i className="fas fa-upload"> File Upload</i>
                                                    </button>
                                                    <button
                                                        onClick={onDownloadFiles}
                                                        style={{marginLeft: 5}}
                                                        className={"btn btn-new-design"}><i
                                                        className="fas fa-download"> Download</i>
                                                    </button>
                                                    <button
                                                        onClick={onDeleteFiles}
                                                        style={{marginLeft: 5}}
                                                        className={"btn btn-danger"}><i
                                                        className="fas fa-trash-alt"> Delete</i>
                                                    </button>
                                                </div>
                                            </div>
                                            <div id={"fileAttachmentsGrid"} className={"ag-theme-balham-dark ag-grids"}
                                                 style={{width: "100%", height: "calc(100% - 45px)", paddingLeft: 5, paddingRight: 5}}/>
                                        </TabPanel>
                                        <TabPanel forceRender={true}>
                                            <div style={{height: 50, width: "100%", backgroundColor: '#2D3436', paddingTop: 5}}>
                                                <div style={{
                                                    width: "100%",
                                                    display: "flex",
                                                    height: 40,
                                                    padding: 2,
                                                    paddingRight: 5,
                                                    paddingLeft: 5
                                                }}>
                                                    <input onInput={onLogFilterTextBoxChanged}
                                                           placeholder={"🔍 Global Search"}
                                                           className={'new-design'}
                                                           id={'log-filter-text-box'}
                                                           style={{width: "inherit", fontSize: 16, border: 'none', borderRadius: 3}}/>
                                                    <button
                                                        onClick={onViewLog}
                                                        style={{marginLeft: 5}}
                                                        id={'view-log-btn'}
                                                        title={'View Log Entry (CTRL + ALT + V)'}
                                                        className={"btn btn-new-design"}>
                                                        <i className="fas fa-eye"/>
                                                        <span className={'icon-style-text'}> <strong className={'shortcut-btn-letters'}>V</strong>iew</span>
                                                    </button>
                                                    <button
                                                        onClick={onLogExport}
                                                        style={{marginLeft: 5}}
                                                        id={'export-log-btn'}
                                                        title={'Export Full Log (CTRL + ALT + X)'}
                                                        className={"btn btn-new-design"}>
                                                        <i className="fas fa-file"/>
                                                        <span className={'icon-style-text'}> <strong className={'shortcut-btn-letters'}>E</strong>xport</span>
                                                    </button>
                                                </div>
                                            </div>
                                            <div id={"logGrid"} className={"ag-theme-balham-dark ag-grids"}
                                                 style={{width: "100%", height: "calc(100% - 45px)", paddingLeft: 5, paddingRight: 5}}/>
                                        </TabPanel>
                                        <TabPanel forceRender={true}>
                                            <div style={{height: 50, width: "100%", backgroundColor: '#2D3436', paddingTop: 5}}>
                                                <div style={{
                                                    width: "100%",
                                                    display: "flex",
                                                    height: 40,
                                                    padding: 2,
                                                    paddingRight: 5,
                                                    paddingLeft: 5
                                                }}>
                                                    <input onInput={onNotificationFilterTextBoxChanged}
                                                           placeholder={"🔍 Global Search"}
                                                           className={'new-design'}
                                                           id={'notification-filter-text-box'}
                                                           style={{width: "inherit", fontSize: 16, border: 'none', borderRadius: 3}}
                                                    />
                                                </div>
                                            </div>
                                            <div id={"notificationGrid"} className={"ag-theme-balham-dark ag-grids"}
                                                 style={{width: "100%", height: "calc(100% - 40px)", paddingLeft: 5, paddingRight: 5}}/>
                                        </TabPanel>
                                    </Tabs>
                                </div>
                            </SplitterLayout>
                        </div>
                        <Prompt message={handleBlockedNavigation}/>
                        <RelationshipsModal {...{save: onSaveRelationships}} ref={relationshipsModal}/>
                        <LookupInstanceModal {...{save: onSaveLookupAttribute}} nextCellForEdit={nextCellForEdit} ref={lookupInstanceModal}/>
                        <AuditLogChangesModal
                            ref={auditLogChangesRef}
                            oldValue={logOldValue}
                            newValue={logNewValue}
                        />
                        <LoadingModal open={loading}/>
                    </div>
                )}
            </Dropzone>
        </div>

    )
}

function attributesGridCellEditorSelector(params: any) {
    if (params.data.type === AttributeTypeEnum.BOOLEAN) {
        const values = ['true', 'false'];
        if (!params.data.required) {
            values.unshift('n/a');
        }
        return {
            component: 'agRichSelect',
            params: { values }
        };
    }
    return { component: 'agInstanceAttributes' };
}

function attributesGridCellRenderer(params: any, attributesGridOptions, locale: { label: string, value: string }) {
    if (!params.node.group) {
        if (params.data.type === AttributeTypeEnum.INT || params.data.type === AttributeTypeEnum.DECIMAL) {
            return `<span>${Utils.numberFormatByLocale(params.value, locale.value)}</span>`;
        }
        if (params.data.type === AttributeTypeEnum.LOOKUP) {
            return `<span>${params.data.value.value || JSON.parse(params.data.value).value}</span>`;
        }
        if (params.data.type === AttributeTypeEnum.EMAIL) {
            return `<span>${Utils.parseEmailAttributeValue(params.value)}</span>`;
        }
        if (params.data.type === AttributeTypeEnum.TEXT || params.data.type === AttributeTypeEnum.JSON) {
            const eDiv = document.createElement('div');
            eDiv.innerHTML = `<span style="max-width: 70%; word-wrap: break-word; white-space: nowrap; text-overflow: ellipsis; overflow: hidden">${params.value}</span>
                            <span><button id="previewTxtBtn" style="float: right; background-color: transparent; border: transparent;">
                                <i class="fas fa-search fa-lg"></i></button></span>`;
            const eButton = eDiv.querySelectorAll('#previewTxtBtn')[0];
            eDiv.style.cssText = 'display: flex; white-space: initial; justify-content: space-between';

            eButton.addEventListener('click', function(event) {
                if (params.data.type === AttributeTypeEnum.TEXT) {
                    showTextArea(event,params, false, attributesGridOptions);
                } else {
                    showJSONComponent(event,params, false, attributesGridOptions);
                }
            });

            return eDiv;
        }
        return `<span>${params.value}</span>`
    }
}

function showJSONComponent(event, params, openedWithKeyCombo, gridOptions) {
    const openedJSONComponent = document.getElementById("json-component");
    const openedTextArea = document.getElementById("text-area");
    const saveAndCloseBtn = document.getElementById("save-and-close-btn");
    const previewHr = document.getElementById("preview-header");

    if (openedTextArea) {
        openedTextArea.remove();
    }
    if (openedJSONComponent) {
        openedJSONComponent.remove();
    }

    if (saveAndCloseBtn) {
        saveAndCloseBtn.remove();
    }

    if (previewHr) {
        previewHr.remove();
    }

    let paramsValue;
    if (!openedWithKeyCombo) {
        if (event.stopImmediatePropagation) {
            event.stopImmediatePropagation();
        }

        try {
            paramsValue = JSON.parse(params.value);
        } catch (e) {
            toastr.warning('The provided JSON is not valid')
        }
    } else {
        try {
            paramsValue = JSON.parse(event.value);
        } catch (e) {
            toastr.warning('The provided JSON is not valid')
        }
    }

    const jsonComponent = document.createElement('div');
    const saveAndClose = document.createElement('button');
    const hr = document.createElement('header');

    hr.style.position = "absolute";
    hr.style.top = "0";
    hr.style.zIndex = "1500";
    hr.style.width = "100%";
    hr.style.backgroundColor = "#2B2B2B";
    hr.style.borderBottom = "1px solid gray";
    hr.style.height = "45px";
    hr.id = "preview-header";

    saveAndClose.classList.add('btn');
    saveAndClose.classList.add('new-design');
    saveAndClose.style.position = "absolute";
    saveAndClose.style.top = "5px";
    saveAndClose.style.right = "5px";
    saveAndClose.style.zIndex = "2000";
    saveAndClose.textContent = 'Save and Close';
    saveAndClose.id = 'save-and-close-btn';

    jsonComponent.style.position = "absolute";
    jsonComponent.style.top = "0";
    jsonComponent.style.width = "100%";
    jsonComponent.style.height = "100%";
    jsonComponent.style.paddingTop = "55px";
    jsonComponent.style.zIndex = "100";
    jsonComponent.style.background = '#2B2B2B';
    jsonComponent.style.fontSize = '14px';
    jsonComponent.id = 'json-component';
    jsonComponent.tabIndex = 3;

    let newValue = paramsValue;

    const editJson = (e) => {
        newValue = e.updated_src;
    }

    const addPropToJson = (e) => {
        newValue = e.updated_src;
    }

    const onDelete = (e) => {
        newValue = e.updated_src;
    }
    let json = null;

    if (params.readonly) {
        json =  <ReactJson style={{background: '#2D3436'}}
                           enableClipboard={false}
                           theme={'tomorrow'}
                           displayDataTypes={false}
                           src={paramsValue} />

    } else {
        json =  <ReactJson style={{background: '#2D3436'}}
                           enableClipboard={false}
                           onEdit={editJson}
                           theme={'tomorrow'}
                           onAdd={addPropToJson}
                           onDelete={onDelete}
                           displayDataTypes={false}
                           src={paramsValue} />
    }

    const paneLayouts = document.getElementsByClassName("layout-pane layout-pane-primary");
    paneLayouts[1].appendChild(jsonComponent);
    paneLayouts[1].appendChild(saveAndClose);
    paneLayouts[1].appendChild(hr);
    ReactDOM.render( json, jsonComponent );
    jsonComponent.focus();

    jsonComponent.addEventListener("keydown", function (zEvent) {
        setTimeout(() => {
            if (zEvent.ctrlKey && zEvent.code === 'Enter') {
                if (params.readonly) {
                    jsonComponent.remove();
                    saveAndClose.remove();
                    hr.remove();
                } else {
                    if (!openedWithKeyCombo) {
                        params.setValue(JSON.stringify(newValue));
                    } else {
                        event.node.setDataValue(event.column.colId, JSON.stringify(newValue))
                    }
                    jsonComponent.remove();
                    saveAndClose.remove();
                    hr.remove();

                    let currentCell = gridOptions.api.getFocusedCell();
                    let finalRowIndex = gridOptions.api.paginationGetRowCount() - 1;

                    // If we are editing the last row in the grid, don't move to next line
                    if (currentCell.rowIndex === finalRowIndex) {
                        gridOptions.api.setFocusedCell(currentCell.rowIndex, 'value', null);
                        return;
                    }

                    gridOptions.api.clearFocusedCell();
                    gridOptions.api.startEditingCell({
                        rowIndex: currentCell.rowIndex + 1,
                        colKey: currentCell.column.colId
                    })
                }
            }
        }, 50)
    });

    saveAndClose.onclick = function () {
        setTimeout(() => {
            if (params.readonly) {
                jsonComponent.remove();
                saveAndClose.remove();
                hr.remove();
            } else {
                if (!openedWithKeyCombo) {
                    params.setValue(JSON.stringify(newValue));
                } else {
                    event.node.setDataValue(event.column.colId, JSON.stringify(newValue))
                }
                jsonComponent.remove();
                saveAndClose.remove();
                hr.remove();

                let currentCell = gridOptions.api.getFocusedCell();
                let finalRowIndex = gridOptions.api.paginationGetRowCount() - 1;

                // If we are editing the last row in the grid, don't move to next line
                if (currentCell.rowIndex === finalRowIndex) {
                    gridOptions.api.setFocusedCell(currentCell.rowIndex, 'value', null);
                    return;
                }

                gridOptions.api.clearFocusedCell();
                gridOptions.api.startEditingCell({
                    rowIndex: currentCell.rowIndex + 1,
                    colKey: currentCell.column.colId
                })
            }
        }, 50)
    }
}

function showTextArea(event, params, openedWithKeyCombo, gridOptions, tinySize?: boolean) {
    const openedTextArea = document.getElementById("text-area");
    const openedJSONComponent = document.getElementById("json-component");
    const saveAndCloseBtn = document.getElementById("save-and-close-btn");
    const previewHr = document.getElementById("preview-header");

    if (openedTextArea) {
        openedTextArea.remove();
    }
    if (openedJSONComponent) {
        openedJSONComponent.remove();
    }

    if (saveAndCloseBtn) {
        saveAndCloseBtn.remove();
    }

    if (previewHr) {
        previewHr.remove();
    }

    let paramsValue;
    if (!openedWithKeyCombo) {
        if (event.stopImmediatePropagation) {
            event.stopImmediatePropagation();
        }
        paramsValue = params.value;
    } else {
        paramsValue = event.value;
    }
    const textArea = document.createElement('textarea');
    const saveAndClose = document.createElement('button');
    const hr = document.createElement('header');

    hr.style.position = "absolute";
    hr.style.top = "0";
    hr.style.zIndex = "1500";
    hr.style.width = "100%";
    hr.style.backgroundColor = "#2D3436";
    hr.style.borderBottom = "1px solid gray";
    hr.style.height = "45px";
    hr.id = "preview-header";

    saveAndClose.classList.add('btn');
    saveAndClose.classList.add('new-design');
    saveAndClose.style.position = "absolute";
    saveAndClose.style.top = "5px";
    saveAndClose.style.right = "5px";
    saveAndClose.style.zIndex = "2000";
    saveAndClose.textContent = 'Save and Close';
    saveAndClose.id = 'save-and-close-btn';

    textArea.classList.add('text-area-for-edit')
    textArea.style.position = "absolute";
    textArea.style.top = "0";
    textArea.style.paddingTop = "50px";
    textArea.style.width = "100%";
    textArea.style.height = tinySize ? "17%" : "100%";
    textArea.style.zIndex = "100";
    textArea.style.fontFamily = 'monospace';
    textArea.style.fontSize = '14px';
    textArea.style.resize = 'none';
    textArea.value = paramsValue;
    textArea.id = 'text-area';

    if (params.readonly) {
        textArea.readOnly = true;
    }
    const paneLayouts = document.getElementsByClassName("layout-pane layout-pane-primary");
    paneLayouts[1].appendChild(textArea);
    paneLayouts[1].appendChild(saveAndClose);
    paneLayouts[1].appendChild(hr);
    textArea.focus();
    textArea.addEventListener("keydown", function (zEvent) {
        if (zEvent.ctrlKey && zEvent.code === 'Enter') {
            if (params.readonly) {
                textArea.remove();
                saveAndClose.remove();
                hr.remove();
            } else {
                if (!openedWithKeyCombo) {
                    params.setValue(textArea.value);
                } else {
                    event.node.setDataValue(event.column.colId, textArea.value)
                }
                textArea.remove();
                saveAndClose.remove();
                hr.remove();

                let currentCell = gridOptions.api.getFocusedCell();
                let finalRowIndex = gridOptions.api.paginationGetRowCount() - 1;

                // If we are editing the last row in the grid, don't move to next line
                if (currentCell.rowIndex === finalRowIndex) {
                    gridOptions.api.setFocusedCell(currentCell.rowIndex, 'value', null);
                    return;
                }

                gridOptions.api.clearFocusedCell();
                gridOptions.api.startEditingCell({
                    rowIndex: currentCell.rowIndex + 1,
                    colKey: currentCell.column.colId
                })
            }
        } else if (params.readonly && zEvent.code === 'Escape') {
            textArea.remove();
            saveAndClose.remove();
            hr.remove();
        }
    });
    textArea.onkeydown = function (event) {
        if(event.keyCode === 9){
            let v = textArea.value, s=textArea.selectionStart, e=textArea.selectionEnd;
            textArea.value = v.substring(0, s) + '\t' + v.substring(e);
            textArea.selectionStart = textArea.selectionEnd = s + 1;
            return false;
        }
    }

    saveAndClose.onclick = function () {
        if (params.readonly) {
            textArea.remove();
            saveAndClose.remove();
            hr.remove();
        } else {
            if (!openedWithKeyCombo) {
                params.setValue(textArea.value);
            } else {
                event.node.setDataValue(event.column.colId, textArea.value)
            }
            textArea.remove();
            saveAndClose.remove();
            hr.remove();

            let currentCell = gridOptions.api.getFocusedCell();
            let finalRowIndex = gridOptions.api.paginationGetRowCount() - 1;

            // If we are editing the last row in the grid, don't move to next line
            if (currentCell.rowIndex === finalRowIndex) {
                gridOptions.api.setFocusedCell(currentCell.rowIndex, 'value', null);
                return;
            }

            gridOptions.api.clearFocusedCell();
            gridOptions.api.startEditingCell({
                rowIndex: currentCell.rowIndex + 1,
                colKey: currentCell.column.colId
            })
        }
    }
}

const buildAttributesGrid = (setGrid: any, lookupInstanceModal: any, businessObjects, locale: { label: string, value: string }) => {
    const gridOptions: any = {
        defaultColDef: {
            filter: "agTextColumnFilter",
            sortable: true,
            resizable: true
        },
        onCellEditingStarted: (params) => {
            if (params.data.type === AttributeTypeEnum.LOOKUP) {
                params.api.stopEditing();
                lookupInstanceModal.current.show(params.data, businessObjects);
            }
        },
        rowData: [],
        floatingFilter: true,
        animateRows: true,
        debug: false,
        groupUseEntireRow: true,
        groupSelectsFiltered: true,
        groupDefaultExpanded: -1,
        singleClickEdit: true,
        suppressDragLeaveHidesColumns: true,
        getRowNodeId: function (data) {
            return data.id;
        },
        columnDefs: [
            {
                field: "uiSection",
                headerName: 'UI Section',
                rowGroup: true,
                hide: true,
            },
            {
                field: 'name',
                headerName: "Attribute Name",
                tooltipField: 'name',
                headerTooltip: "Attribute Name",
                width: 50,
                suppressNavigable: true
            },
            {
                field: 'type',
                headerName: "Type",
                tooltipField: 'type',
                headerTooltip: "Attribute Type",
                width: 50,
                suppressNavigable: true
            },
            {
                editable: true,
                field: 'value',
                colKey: 'value',
                headerName: "Value",
                tooltipField: 'value',
                headerTooltip: "Attribute Value",
                cellEditorSelector: params => attributesGridCellEditorSelector(params),
                width: 50,
                cellRenderer: (params) => attributesGridCellRenderer(params, gridOptions, locale)
            },
        ],
        components: {
            agInstanceAttributes: getAttributesEditor()
        },
        onGridReady: (params: any) => {
            params.api.sizeColumnsToFit();
        },
        onCellKeyDown: (e) => {
            if (e.event.ctrlKey && e.event.altKey) {
                gridOptions.api.stopEditing();
            }
            if (e.data.type === AttributeTypeEnum.TEXT || e.data.type === AttributeTypeEnum.JSON) {
                if (e.event.shiftKey && e.event.code === 'Enter') {
                    gridOptions.api.stopEditing();
                    if (e.data.type === AttributeTypeEnum.JSON) {
                        showJSONComponent(e,e,true, gridOptions);
                    } else {
                        showTextArea(e,e,true, gridOptions);
                    }
                }
            }
        }
    };


    const grid: any = new agGrid.Grid(document.getElementById("attributesGrid"), gridOptions);

    gridOptions.api.getAllRows = (): any[] => {
        const data = [];
        gridOptions.api.rowModel.gridApi.forEachNode((node) => {
            if (!node.group)
                data.push(node.data);
        });
        return data
    };

    setGrid(grid);
};

const buildFileAttachmentsGrid = (setGrid: any) => {
    const gridOptions: any = {
        defaultColDef: {
            filter: "agTextColumnFilter",
            sortable: true,
            resizable: true
        },
        rowData: [],
        suppressDragLeaveHidesColumns: true,
        floatingFilter: true,
        rowSelection: 'multiple',
        columnDefs: [
            {
                field: 'name',
                headerName: "Name",
                tooltipField: 'name',
                headerTooltip: "Name",
                checkboxSelection: true,
                headerCheckboxSelection: true
            },
            {
                field: 'updated',
                headerName: "Updated",
                tooltipField: 'updated',
                headerTooltip: "Updated",
            }
        ],
    };

    const grid: any = new agGrid.Grid(document.getElementById("fileAttachmentsGrid"), gridOptions);

    gridOptions.api.getAllRows = (): any[] => {
        const data = [];
        gridOptions.api.rowModel.gridApi.forEachNode((node) => {
            data.push(node.data);
        });
        return data
    };

    setGrid(grid);
};

const loadingTags = (inputValue: string, callback: any) => {
    Axios.instance.get(`tags`)
        .then((response: any) => {
            const data = response.data
                .map(item => {
                    return {
                        label: item,
                        value: item
                    }
                })
                .filter(item => item.label.toLowerCase().includes(inputValue.toLowerCase()));
            callback(data);
        })
};

const getAttributes = (attributes: any[]): any[] => {
    return attributes.map(item => {
        const column = {
            id: item.attribute.id,
            name: item.attribute.name,
            type: item.attribute.type,
            uiSection: item.attribute.uiSection,
            attributeValues: item.attribute.attributeValues,
            lookupRelTypeId: item.attribute.lookupRelTypeId,
            lookupAttributeId: item.attribute.lookupAttributeId,
            defaultValue: item.attribute.defaultValue,
            oldValue: item.attribute.oldValue,
            newValue: item.attribute.newValue,
            required: item.attribute.required
        };
        switch (column.type) {
            case AttributeTypeEnum.JSON:
                column['value'] = item.value;
                column['oldValue'] = item.oldValue;
                column['newValue'] = item.newValue;
                column["cellEditorParams"] = {
                    isPopup: true,
                    maxLength: item.attribute.maxLength <= 0 ? 1000 : item.attribute.maxLength,
                    cols: '50',
                    rows: '6'
                };
                break;
            case AttributeTypeEnum.TEXT:
                column['value'] = item.value;
                column['oldValue'] = item.oldValue;
                column['newValue'] = item.newValue;
                column["cellEditorParams"] = {
                    isPopup: true,
                    maxLength: item.attribute.maxLength <= 0 ? 250 : item.attribute.maxLength,
                    cols: '50',
                    rows: '2'
                };
                break;
            case AttributeTypeEnum.VALUE_LIST:
            case AttributeTypeEnum.EMAIL:
                column['value'] = item.value;
                column['oldValue'] = item.oldValue;
                column['newValue'] = item.newValue;
                column["cellEditorParams"] = {
                    isPopup: true
                };
                break;
            default:
                column['value'] = item.value;
                column['oldValue'] = item.oldValue;
                column['newValue'] = item.newValue;
        }
        return column
    })
};



// WEBPACK FOOTER //
// ./app/components/bo-core/InstanceGridEditor.tsx